import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { AuthService } from 'src/services/auth.service';
import { LocalSessionService } from 'src/services/local-session.service';
import { VehicleService } from 'src/services/vehicle.service';
import { PayMayaService } from 'src/services/paymaya.service';
import { PaymayaPaymentService } from 'src/services/paymaya-payment.service';
import { FcmNotificationService } from 'src/services/fcm-notification.service';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import firebase from 'firebase';
import Swal from 'sweetalert2';
import { RouteHelperService } from 'src/services/route-helper.service';
import { environment } from 'src/environments/environment';

interface ParkingRecord {
  id: string;
  uid?: string;
  user_id?: string;
  code?: string;
  account_key?: string;
  plate_number: string;
  vehicle_type: string;
  vehicle_type_custom_name?: string;
  vehicle_model?: string;
  vehicle_color?: string;
  geotag?: GeotagPhoto | any;
  transaction_type?: number;
  parking_duration?: number;
  entry_status?: boolean;
  date_registered?: any;
  date_updated?: any;
  created_at?: any;
  timestamp?: any;
  time_in: string;
  time_out?: string;
  payment_action_type?: number;
  ticket_number?: string;
  processedBy?: string;
  processedBy_id?: string;
  zone_name: string;
  zone_id?: string;
  original_amount_due?: number;
  noplate?: string;
  unpaid?: string;
  zone_slot_assignment?: number;
  auto_end_time?: string | Date | any;
  actual_end_time?: string | Date | any;
  selected_duration?: number;
  duration_hours?: number;
  initial_payment?: number;
  additional_payment?: number;
  calculated_for_duration?: number;
  is_manual_assignment?: boolean;
  slot_id?: string;
  slot_name: string;
  slot_code?: string;
  slot_arrangement?: number;
  updated_at?: any;
  additional_payment_recieved_date?: any;
  amount_paid?: number;
  amount_due_paid?: number;
  payment_id?: string;
  payment_status?: boolean | string;
  paid: boolean;
  additional_payment_recieved_by_id?: string;
  amount_due?: number;
  reference_number?: string;
  additional_payment_recieved_by?: string;
  payment_type?: string;
  discount_applied?: boolean;
  discounted_amount?: number;
  original_amount?: number;
  discount_details?: string;
  initial_payment_recieved_by_id?: string;
  initial_payment_recieved_by?: string;
  discount_percent?: number;
  discount_savings?: number;
  payment_date?: any;
  initial_payment_recieved_date?: any;
  allow_background_processing?: boolean;
  expired_at?: any;
  isExpired?: boolean;
  last_synced_at?: any;
  last_sync_status?: number;
  session_status_text?: string;
  auto_completed_at?: any;
  being_processed_by?: string;
  exit_status?: boolean;
  session_status: number;
  auto_completed?: boolean;
  status?: string;
  updatedAt?: any;
  remarks?: string;
  transaction_type_name?: string;
  date_paid?: string;
  calculatedAmount?: number;
  duration?: string;
  payment_method?: string;
  payment_scheme?:string;
}

interface PaymentRecord {
  id: string;
  amount: number;
  date_paid: string;
  payment_method: string;
  fundSource: {
    type: string;
  };
  plate_number: string;
  zone_name: string;
  slot_name?: string;
  status: string;
  checkout_id?: string;
  transaction_reference?: string;
  // Bulk payment fields
  is_bulk_payment?: boolean;
  session_count?: number;
  plate_numbers?: string[];
  zone_names?: string;
  parking_session_ids?: string[];
  sessions_detail?: {
    id: string;
    plate_number: string;
    zone_name: string;
    slot_name: string;
    time_in: string;
    time_out?: string;
    auto_end_time?: string;
    amount: number;
  }[];
  payment_type?: string;
  // Metadata field
  metadata?: {
    parking_session_id?: string;
    payment_source?: string;
    plate_number?: string;
    user_id?: string;
    zone_name?: string;
    [key: string]: any;
  };
}

interface GeotagPhoto {
  id: string;
  geotagImage: string;
  plateNumber: string;
  address: string;
  lat: number;
  lng: number;
  timestamp: any;
  accuracy?: number;
  gateKeeperInfo?: any;
}

interface Violation {
  id: string;
  plate_number: string;
  violation_type: string;
  description: string;
  date: string;
  status: string;
  fine_amount?: number;
}

interface DriverNotification {
  id: string;
  plate_number: string;
  type: 'new_session' | 'session_expired' | 'session_completed';
  title: string;
  message: string;
  session_id: string;
  slot_code: string | null;
  slot_id: string | null;
  slot_name: string | null;
  zone_id: string | null;
  zone_name: string | null;
  is_read: boolean;
  created_at: any;
  read_at: any | null;
  metadata?: {
    auto_end_time?: any;
    expired_at?: any;
    completed_at?: any;
  };
}

interface UserVehicle {
  id?: string;
  user_id?: string;
  owner_id?: string;
  plate_number: string;
  vehicle_type: string;
  vehicle_model?: string;
  vehicle_color?: string;
  vehicle_type_custom_name?: string;
  vin_number?: string;
  code?: string;
  latest_log_id?: string;
  previous_owner_id?: string | null;
  deleted?: boolean;
  
  // Owner information (for registration forms)
  owner_full_name?: string;
  owner_contact_number?: string;
  owner_email?: string;
  owner_address?: string;
  driver_license_number?: string;
  license_expiry_date?: string;
  
  // Document files/URLs
  cr_document?: File | string;
  or_document?: File | string;
  government_id?: File | string;
  drivers_license?: File[] | string[];
  insurance_document?: File | string;
  uploaded_documents?: any;
  
  // Timestamps
  date_created?: Date | any;
  date_registered?: Date | any;
  updated_at?: Date | any;
  updatedAt?: Date | any;
  
  // Verification status
  verification_status?: 'pending' | 'verified' | 'rejected' | string;
  rejection_reason?: string;
  verified_by?: string;
  verified_date?: Date | any;
}

interface RegistrationStep {
  title: string;
  description: string;
}


@Component({
  selector: 'app-public-user-dashboard',
  templateUrl: './user-dashboard.component.html',
  styleUrls: ['./user-dashboard.component.css']
})
export class PublicUserDashboardComponent implements OnInit, OnDestroy {

  user: any;
  isAdminAccess: boolean = false;
  adminSessionData: any = null;
  activeTab: string = 'parking';
  
  // Data properties
  parkingRecords: ParkingRecord[] = [];
  paymentRecords: PaymentRecord[] = [];
  geotagPhotos: GeotagPhoto[] = [];
  violations: Violation[] = [];
  driverNotifications: DriverNotification[] = [];

  // Loading states
  isLoading: boolean = false;
  isLoadingParkingRecords: boolean = false;
  isLoadingPayments: boolean = false;
  isLoadingPhotos: boolean = false;
  isLoadingViolations: boolean = false;
  isLoadingNotifications: boolean = false;

  // Stats
  totalParkingSessions: number = 0;
  totalPaidAmount: number = 0;
  unpaidSessions: number = 0;
  activeViolations: number = 0;
  unreadNotificationsCount: number = 0;

  // Vehicle management properties
  userVehicles: UserVehicle[] = [];
  showVehicleForm: boolean = false;
  demoMode: boolean = true; // Enable demo mode for simplified flow
  newVehicle: UserVehicle = {
    plate_number: '',
    vehicle_type: '',
    vehicle_model: '',
    vehicle_color: '',
    vin_number: '',
    owner_full_name: '',
    owner_contact_number: '',
    owner_email: '',
    owner_address: '',
    driver_license_number: '',
    license_expiry_date: '',
    drivers_license: []
  };
  isLoadingVehicles: boolean = false;
  isSubmittingVehicle: boolean = false;
  vehicleError: string = '';

  // Multi-step form properties
  currentStep: number = 1;
  declarationAccepted: boolean = false;
  registrationSteps: RegistrationStep[] = [
    { title: 'Vehicle Details', description: 'Basic vehicle information' },
    { title: 'Owner Details', description: 'Owner information as per documents' },
    { title: 'Driver Verification', description: 'Driver license information' },
    { title: 'Document Uploads', description: 'Required documents' },
    { title: 'Declaration', description: 'Review and confirmation' },
    { title: 'Status', description: 'Registration complete' }
  ];

  // Document thumbnail properties
  documentPreviews: { [key: string]: string | string[] } = {};
  
  // Math reference for template
  Math = Math;

  // Payment modal properties
  selectedUnpaidRecord: ParkingRecord | null = null;
  calculatedAmount: number = 0;
  isProcessingPayment: boolean = false;
  paymentError: string = '';

  // Unpaid records
  unpaidRecords: ParkingRecord[] = [];

  // Search, filter, and sort properties
  searchQuery: string = '';
  paymentStatusFilter: string = 'all';
  paymentMethodFilter: string = 'all';
  dateRangeFilter: string = 'all';
  sortOption: string = 'status_date';
  filteredParkingRecords: ParkingRecord[] = [];
  
  // Custom date range properties
  customStartDate: string = '';
  customEndDate: string = '';

  // Real-time listeners cleanup
  private unsubscribers: (() => void)[] = [];
  private vehicleUnsubscriber: (() => void) | null = null;
  private paymentUnsubscriber: (() => void) | null = null;
  private notificationsUnsubscriber: (() => void) | null = null;

  // Notification permissions
  notificationPermission: NotificationPermission = 'default';

  constructor(
    private authService: AuthService,
    private localSessionService: LocalSessionService,
    private vehicleService: VehicleService,
    private payMayaService: PayMayaService,
    private paymayaPaymentService: PaymayaPaymentService,
    private fcmNotificationService: FcmNotificationService,
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient,
    private cdr: ChangeDetectorRef,
    public routeHelper: RouteHelperService
  ) { }

  async ngOnInit() {
    // Check for admin access first
    this.checkAdminAccess();

    // Enhanced authentication check
    const isAuthenticated = await this.validateUserAuthentication();
    if (!isAuthenticated) {
      return;
    }

    // Request notification permission
    await this.requestNotificationPermission();

    await this.loadDashboardDataRealtime();

    // Check if we should show payment modal on return from payment
    this.route.queryParams.subscribe(params => {
      if (params['showPayment'] === 'true' && this.unpaidRecords.length > 0) {
        // Auto-open payment modal for the first unpaid record
        setTimeout(() => this.openPaymentModal(this.unpaidRecords[0]), 1000);
      }

      // Handle payment status returns
      if (params['payment_status']) {
        this.handlePaymentStatusReturn(params['payment_status'], params['transaction_id']);
      }
    });
  }

  ngOnDestroy() {
    // Clean up all real-time listeners
    this.unsubscribers.forEach(unsubscribe => {
      if (unsubscribe) {
        unsubscribe();
      }
    });

    if (this.vehicleUnsubscriber) {
      this.vehicleUnsubscriber();
    }

    if (this.paymentUnsubscriber) {
      this.paymentUnsubscriber();
    }

    if (this.notificationsUnsubscriber) {
      this.notificationsUnsubscriber();
    }

    this.unsubscribers = [];
    this.vehicleUnsubscriber = null;
    this.paymentUnsubscriber = null;
    this.notificationsUnsubscriber = null;
  }

  private checkAdminAccess(): void {
    // Check for admin access parameters
    const urlParams = new URLSearchParams(window.location.search);
    const isAdminAccess = urlParams.get('admin_access') === 'true';
    const targetUserId = urlParams.get('user_id');

    if (isAdminAccess && targetUserId) {
      // Validate admin session data
      const adminSessionData = sessionStorage.getItem('admin_user_access');
      if (adminSessionData) {
        try {
          this.adminSessionData = JSON.parse(adminSessionData);

          // Validate admin session
          if (this.adminSessionData.targetUserId === targetUserId) {
            // Check if session is not too old (30 minutes)
            const sessionTime = new Date(this.adminSessionData.timestamp);
            const now = new Date();
            const diffMinutes = (now.getTime() - sessionTime.getTime()) / (1000 * 60);

            if (diffMinutes < 30) {
              this.isAdminAccess = true;
              console.log('Admin access authenticated for user:', targetUserId);

              // Update session timestamp to extend it
              this.adminSessionData.timestamp = now.toISOString();
              sessionStorage.setItem('admin_user_access', JSON.stringify(this.adminSessionData));
            } else {
              console.warn('Admin session expired');
              sessionStorage.removeItem('admin_user_access');
            }
          }
        } catch (error) {
          console.error('Invalid admin session data:', error);
          sessionStorage.removeItem('admin_user_access');
        }
      }
    }
  }

  private async validateUserAuthentication(): Promise<boolean> {
    if (this.isAdminAccess && this.adminSessionData) {
      // For admin access, load the target user's data and skip local session validation
      const userLoaded = await this.loadTargetUserData(this.adminSessionData.targetUserId);
      if (userLoaded) {
        console.log('Admin access validated successfully');
        return true;
      }
      return false;
    }

    // Normal user authentication flow
    // Check for user in localStorage
    this.user = JSON.parse(localStorage.getItem('user') || '{}');
    if (!this.user || !this.user.uid) {
      console.log('No authenticated user found');
      this.router.navigate([this.routeHelper.getRoutes().auth]);
      return false;
    }

    // Validate local session (only for normal users, not admin access)
    const currentSession = this.localSessionService.getCurrentSession();
    if (!currentSession || currentSession.uid !== this.user.uid) {
      console.log('Invalid or expired session');
      this.localSessionService.clearSession();
      localStorage.removeItem('user');
      this.router.navigate([this.routeHelper.getRoutes().auth]);
      return false;
    }

    // Update last access time
    this.localSessionService.updateLastLogin();

    return true;
  }

  private async loadTargetUserData(userId: string): Promise<boolean> {
    try {
      // Load user data from Firestore using the user service
      const userDoc = await firebase.firestore().collection('users').doc(userId).get();

      if (userDoc.exists) {
        const userData = userDoc.data();
        this.user = { id: userId, uid: userId, ...userData };

        // For admin access, store temp data in a separate key to avoid overwriting admin's auth
        const tempUserData = {
          uid: userId,
          id: userId,
          isAdminAccess: true,
          ...userData
        };

        // Store in a separate localStorage key for admin access
        localStorage.setItem('temp_user_for_admin', JSON.stringify(tempUserData));

        // Create a minimal localStorage 'user' entry that satisfies auth checks
        // but doesn't overwrite admin's actual user data
        const minimalUserData = {
          uid: userId,
          id: userId,
          phoneNumber: userData.phoneNumber || 'admin-access',
          displayName: userData.displayName || 'Admin Access User',
          email: userData.email || '',
          isAdminAccess: true
        };
        localStorage.setItem('user', JSON.stringify(minimalUserData));

        // Create a temporary local session to satisfy session validation
        const phoneNumber = userData.phoneNumber || 'admin-access';
        const displayName = userData.displayName || 'Admin Access User';
        const email = userData.email || '';

        this.localSessionService.createSession(phoneNumber, userId, displayName, email);

        console.log('Target user data and session created for admin access:', this.user);
        return true;
      } else {
        console.error('Target user not found:', userId);
        this.router.navigate(['/admin/myparking-access']);
        return false;
      }
    } catch (error) {
      console.error('Error loading target user data:', error);
      this.router.navigate(['/admin/myparking-access']);
      return false;
    }
  }

  async loadDashboardData() {
    this.isLoading = true;
    try {
      // Load vehicles first, then parking records, then payment records (which depend on parking records)
      await this.loadUserVehicles();
      await this.loadParkingRecords();
      await this.loadPaymentRecords();
      
      // Load remaining data in parallel
      await Promise.all([
        this.loadViolations()
      ]);
      
      this.calculateStats();
    } catch (error) {
      console.error('Error loading dashboard data:', error);
    } finally {
      this.isLoading = false;
    }
  }

  async loadDashboardDataRealtime() {
    this.isLoading = true;
    try {
      // Set up real-time listeners - vehicles first, then other listeners after vehicles are loaded
      this.setupUserVehiclesListener();
      // Note: setupParkingRecordsListener(), setupPaymentRecordsListener(), and setupNotificationsListener()
      // are now called from within setupUserVehiclesListener() after vehicles are loaded
      // to ensure verified vehicles are available for filtering

      // Load remaining data in parallel (these don't need real-time for now)
      await Promise.all([
        this.loadViolations()
      ]);

    } catch (error) {
      console.error('Error setting up real-time dashboard data:', error);
    } finally {
      this.isLoading = false;
    }
  }

  async loadUserVehicles() {
    this.isLoadingVehicles = true;
    try {
      // Use Cloud Function to get user vehicles
      const response = await this.http.post(`${environment.apiBaseUrl}/getUserVehicles`, {
        owner_id: this.user.uid
      }).toPromise();
      
      if (response && Array.isArray(response)) {
        this.userVehicles = response.map(vehicle => ({
          ...vehicle,
          date_registered: vehicle.date_registered ? new Date(vehicle.date_registered) : null
        }));
      } else {
        this.userVehicles = [];
      }

    } catch (error) {
      console.error('Error loading user vehicles:', error);
      this.userVehicles = [];
    } finally {
      this.isLoadingVehicles = false;
    }
  }

  setupUserVehiclesListener() {
    this.isLoadingVehicles = true;
    
    // Clean up existing listener if any
    if (this.vehicleUnsubscriber) {
      this.vehicleUnsubscriber();
    }
    
    // Set up real-time listener for user vehicles
    this.vehicleUnsubscriber = firebase.firestore()
      .collection('vehicles')
      .where('owner_id', '==', this.user.uid)
      .onSnapshot((snapshot) => {
        
        this.userVehicles = [];
        snapshot.forEach(doc => {
          const data = doc.data();
          this.userVehicles.push({
            id: doc.id,
            ...data,
            date_registered: data.date_registered ? new Date(data.date_registered.seconds * 1000) : null,
            date_created: data.date_created ? new Date(data.date_created.seconds * 1000) : null,
            verified_date: data.verified_date ? new Date(data.verified_date.seconds * 1000) : null,
            updated_at: data.updated_at ? new Date(data.updated_at.seconds * 1000) : null,
            updatedAt: data.updatedAt ? new Date(data.updatedAt.seconds * 1000) : null
          } as UserVehicle);
        });
        
        // Sort by registration date, newest first
        this.userVehicles.sort((a, b) => {
          const dateA = a.date_registered ? new Date(a.date_registered).getTime() : 0;
          const dateB = b.date_registered ? new Date(b.date_registered).getTime() : 0;
          return dateB - dateA;
        });
        
        // Check if user needs to register a vehicle first (but respect cancellation)
        if (this.shouldRedirectToVehicleRegistration() && localStorage.getItem('cancelVehicleCheck') !== 'true') {
          this.router.navigate([this.routeHelper.getRoutes().vehicleRegistration]);
          return;
        }
        
        // Clear cancellation flag if user made it to dashboard
        if (localStorage.getItem('cancelVehicleCheck') === 'true') {
          localStorage.removeItem('cancelVehicleCheck');
        }
        
        // Set up parking records listener after vehicles are loaded
        this.setupParkingRecordsListener();

        // Set up payment records listener after vehicles are loaded
        this.setupPaymentRecordsListener();

        // Set up notifications listener after vehicles are loaded
        this.setupNotificationsListener();

        this.isLoadingVehicles = false;
        this.cdr.detectChanges();
      }, (error) => {
        console.error('Error in vehicles real-time listener:', error);
        this.isLoadingVehicles = false;
        this.cdr.detectChanges();
      });
  }

  setupParkingRecordsListener() {
    
    // Get user's verified vehicles first
    const verifiedVehicles = this.userVehicles.filter(v => v.verification_status === 'verified');
    
    if (verifiedVehicles.length === 0) {
      this.parkingRecords = [];
      this.calculateStats();
      return;
    }
    
    this.isLoadingParkingRecords = true;
    
    // For parking records, we'll use the searchPlateNumber API for each vehicle
    // and refresh it periodically since it's not directly in Firestore
    this.loadParkingRecordsFromAPI();
    
    // Set up periodic refresh for parking records (every 30 seconds)
    // const intervalId = setInterval(() => {
    //   if (this.userVehicles.filter(v => v.verification_status === 'verified').length > 0) {
    //     this.loadParkingRecordsFromAPI();
    //   }
    // }, 30000);
    
    // Store the interval cleanup function
    // this.unsubscribers.push(() => {
    //   clearInterval(intervalId);
    // });
  }

  async loadParkingRecordsFromAPI() {
    try {
      // Get user's verified vehicles
      const verifiedVehicles = this.userVehicles.filter(v => v.verification_status === 'verified');
      
      if (verifiedVehicles.length > 0) {
        const allParkingRecords: ParkingRecord[] = [];
        
        for (const vehicle of verifiedVehicles) {
          try {
            const response: any = await this.http.post(`${environment.apiBaseUrl}/searchPlateNumber`, {
              plate_number: vehicle.plate_number
            }).toPromise();
            
            if (response && response.success && response.logs && Array.isArray(response.logs)) {

               const vehicleRecords: ParkingRecord[] = response.logs.map((log: any) => ({
                 id: log.id,
                 uid: log.uid,
                 user_id: log.user_id,
                 code: log.code,
                 account_key: log.account_key,
                 plate_number: log.plate_number,
                 vehicle_type: log.vehicle_type,
                 vehicle_type_custom_name: log.vehicle_type_custom_name,
                 vehicle_model: log.vehicle_model,
                 vehicle_color: log.vehicle_color,
                 geotag: log.geotag,
                 transaction_type: log.transaction_type,
                 parking_duration: log.parking_duration,
                 entry_status: log.entry_status,
                 date_registered: log.date_registered,
                 date_updated: log.date_updated,
                 created_at: log.created_at,
                 timestamp: log.timestamp,
                 time_in: log.time_in,
                 time_out: log.time_out,
                 payment_action_type: log.payment_action_type,
                 ticket_number: log.ticket_number,
                 processedBy: log.processedBy,
                 processedBy_id: log.processedBy_id,
                 zone_name: log.zone_name,
                 zone_id: log.zone_id,
                 original_amount_due: log.original_amount_due,
                 noplate: log.noplate,
                 unpaid: log.unpaid,
                 zone_slot_assignment: log.zone_slot_assignment,
                 auto_end_time: log.auto_end_time,
                 actual_end_time: log.actual_end_time,
                 selected_duration: log.selected_duration,
                 duration_hours: log.duration_hours,
                 initial_payment: log.initial_payment,
                 additional_payment: log.additional_payment,
                 calculated_for_duration: log.calculated_for_duration,
                 is_manual_assignment: log.is_manual_assignment,
                 slot_id: log.slot_id,
                 slot_name: log.slot_name,
                 slot_code: log.slot_code,
                 slot_arrangement: log.slot_arrangement,
                 updated_at: log.updated_at,
                 additional_payment_recieved_date: log.additional_payment_recieved_date,
                 amount_paid: log.amount_paid,
                 amount_due_paid: log.amount_due_paid,
                 payment_id: log.payment_id,
                 payment_status: log.payment_status,
                 paid: log.paid,
                 additional_payment_recieved_by_id: log.additional_payment_recieved_by_id,
                 amount_due: log.amount_due,
                 reference_number: log.reference_number,
                 additional_payment_recieved_by: log.additional_payment_recieved_by,
                 payment_type: log.payment_type,
                 discount_applied: log.discount_applied,
                 discounted_amount: log.discounted_amount,
                 original_amount: log.original_amount,
                 discount_details: log.discount_details,
                 initial_payment_recieved_by_id: log.initial_payment_recieved_by_id,
                 initial_payment_recieved_by: log.initial_payment_recieved_by,
                 discount_percent: log.discount_percent,
                 discount_savings: log.discount_savings,
                 payment_date: log.payment_date,
                 initial_payment_recieved_date: log.initial_payment_recieved_date,
                 allow_background_processing: log.allow_background_processing,
                 expired_at: log.expired_at,
                 isExpired: log.isExpired,
                 last_synced_at: log.last_synced_at,
                 last_sync_status: log.last_sync_status,
                 session_status_text: log.session_status_text || this.getPaymentStatusText(log.paid, log.payment_status),
                 auto_completed_at: log.auto_completed_at,
                 being_processed_by: log.being_processed_by,
                 exit_status: log.exit_status,
                 session_status: log.session_status || 0,
                 auto_completed: log.auto_completed,
                 status: log.status || this.getRecordStatus(log.paid, log.payment_status, log.session_status),
                 updatedAt: log.updatedAt,
                 remarks: log.remarks,
                 transaction_type_name: log.transaction_type_name,
                 date_paid: log.date_paid,
                 calculatedAmount: log.calculatedAmount,
                 duration: log.duration
               }));
              
              allParkingRecords.push(...vehicleRecords);
            }
          } catch (vehicleError) {
            console.error(`Error loading records for vehicle ${vehicle.plate_number}:`, vehicleError);
          }
        }
        
        // Merge payment records with parking records
        const recordsWithPaymentData = await this.mergePaymentRecords(allParkingRecords);
        
        // Sort all records by unpaid status first, then by time_in descending and limit to 50 most recent
        const newParkingRecords = recordsWithPaymentData
          .sort((a, b) => {
            // First sort by payment status - unpaid records first
            const aIsUnpaid = this.shouldShowPayNowButton(a) && !a.paid;
            const bIsUnpaid = this.shouldShowPayNowButton(b) && !b.paid;
            
            if (aIsUnpaid && !bIsUnpaid) return -1;
            if (!aIsUnpaid && bIsUnpaid) return 1;
            
            // If both have same payment status, sort by time_in descending (newest first)
            const dateA = new Date(a.time_in || 0).getTime();
            const dateB = new Date(b.time_in || 0).getTime();
            return dateB - dateA;
          })
          .slice(0, 50);
          
        // Only update if there are actual changes to prevent unnecessary re-renders
        if (JSON.stringify(this.parkingRecords) !== JSON.stringify(newParkingRecords)) {
          this.parkingRecords = newParkingRecords;
          this.applyFiltersAndSort();
          this.updateGeotagPhotosFromParkingRecords();
          this.calculateStats();
          this.cdr.detectChanges();
        }
      } else {
        this.parkingRecords = [];
        this.applyFiltersAndSort();
        this.calculateStats();
      }
      
    } catch (error) {
      console.error('Error loading parking records from API:', error);
    } finally {
      this.isLoadingParkingRecords = false;
    }
  }

  async loadParkingRecords() {
    this.isLoadingParkingRecords = true;
    try {
      // Get user's verified vehicles first
      const verifiedVehicles = this.userVehicles.filter(v => v.verification_status === 'verified');
      
      if (verifiedVehicles.length > 0) {
        // Use searchPlateNumber cloud function to get comprehensive parking data for each vehicle
        const allParkingRecords: ParkingRecord[] = [];
        
        for (const vehicle of verifiedVehicles) {
          try {
            const response: any = await this.http.post(`${environment.apiBaseUrl}/searchPlateNumber`, {
              plate_number: vehicle.plate_number
            }).toPromise();
            
            if (response && response.success && response.logs && Array.isArray(response.logs)) {
               // Convert the response logs to ParkingRecord format with all available fields
               const vehicleRecords: ParkingRecord[] = response.logs.map((log: any) => ({
                 id: log.id,
                 uid: log.uid,
                 user_id: log.user_id,
                 code: log.code,
                 account_key: log.account_key,
                 plate_number: log.plate_number,
                 vehicle_type: log.vehicle_type,
                 vehicle_type_custom_name: log.vehicle_type_custom_name,
                 vehicle_model: log.vehicle_model,
                 vehicle_color: log.vehicle_color,
                 geotag: log.geotag,
                 transaction_type: log.transaction_type,
                 parking_duration: log.parking_duration,
                 entry_status: log.entry_status,
                 date_registered: log.date_registered,
                 date_updated: log.date_updated,
                 created_at: log.created_at,
                 timestamp: log.timestamp,
                 time_in: log.time_in,
                 time_out: log.time_out,
                 payment_action_type: log.payment_action_type,
                 ticket_number: log.ticket_number,
                 processedBy: log.processedBy,
                 processedBy_id: log.processedBy_id,
                 zone_name: log.zone_name,
                 zone_id: log.zone_id,
                 original_amount_due: log.original_amount_due,
                 noplate: log.noplate,
                 unpaid: log.unpaid,
                 zone_slot_assignment: log.zone_slot_assignment,
                 auto_end_time: log.auto_end_time,
                 actual_end_time: log.actual_end_time,
                 selected_duration: log.selected_duration,
                 duration_hours: log.duration_hours,
                 initial_payment: log.initial_payment,
                 additional_payment: log.additional_payment,
                 calculated_for_duration: log.calculated_for_duration,
                 is_manual_assignment: log.is_manual_assignment,
                 slot_id: log.slot_id,
                 slot_name: log.slot_name,
                 slot_code: log.slot_code,
                 slot_arrangement: log.slot_arrangement,
                 updated_at: log.updated_at,
                 additional_payment_recieved_date: log.additional_payment_recieved_date,
                 amount_paid: log.amount_paid,
                 amount_due_paid: log.amount_due_paid,
                 payment_id: log.payment_id,
                 payment_status: log.payment_status,
                 paid: log.paid,
                 additional_payment_recieved_by_id: log.additional_payment_recieved_by_id,
                 amount_due: log.amount_due,
                 reference_number: log.reference_number,
                 additional_payment_recieved_by: log.additional_payment_recieved_by,
                 payment_type: log.payment_type,
                 discount_applied: log.discount_applied,
                 discounted_amount: log.discounted_amount,
                 original_amount: log.original_amount,
                 discount_details: log.discount_details,
                 initial_payment_recieved_by_id: log.initial_payment_recieved_by_id,
                 initial_payment_recieved_by: log.initial_payment_recieved_by,
                 discount_percent: log.discount_percent,
                 discount_savings: log.discount_savings,
                 payment_date: log.payment_date,
                 initial_payment_recieved_date: log.initial_payment_recieved_date,
                 allow_background_processing: log.allow_background_processing,
                 expired_at: log.expired_at,
                 isExpired: log.isExpired,
                 last_synced_at: log.last_synced_at,
                 last_sync_status: log.last_sync_status,
                 session_status_text: log.session_status_text || this.getPaymentStatusText(log.paid, log.payment_status),
                 auto_completed_at: log.auto_completed_at,
                 being_processed_by: log.being_processed_by,
                 exit_status: log.exit_status,
                 session_status: log.session_status || 0,
                 auto_completed: log.auto_completed,
                 status: log.status || this.getRecordStatus(log.paid, log.payment_status, log.session_status),
                 updatedAt: log.updatedAt,
                 remarks: log.remarks,
                 transaction_type_name: log.transaction_type_name,
                 date_paid: log.date_paid,
                 calculatedAmount: log.calculatedAmount,
                 duration: log.duration
               }));
              
              allParkingRecords.push(...vehicleRecords);
            }
          } catch (vehicleError) {
            console.error(`Error loading records for vehicle ${vehicle.plate_number}:`, vehicleError);
            // Continue with other vehicles even if one fails
          }
        }
        
        // Merge payment records with parking records
        const recordsWithPaymentData = await this.mergePaymentRecords(allParkingRecords);
        
        // Sort all records by unpaid status first, then by time_in descending and limit to 50 most recent
        this.parkingRecords = recordsWithPaymentData
          .sort((a, b) => {
            // First sort by payment status - unpaid records first
            const aIsUnpaid = this.shouldShowPayNowButton(a) && !a.paid;
            const bIsUnpaid = this.shouldShowPayNowButton(b) && !b.paid;
            
            if (aIsUnpaid && !bIsUnpaid) return -1;
            if (!aIsUnpaid && bIsUnpaid) return 1;
            
            // If both have same payment status, sort by time_in descending (newest first)
            const dateA = new Date(a.time_in || 0).getTime();
            const dateB = new Date(b.time_in || 0).getTime();
            return dateB - dateA;
          })
          .slice(0, 50);
        this.applyFiltersAndSort();
      } else {
        // No verified vehicles, show empty state
        this.parkingRecords = [];
        this.applyFiltersAndSort();
      }
      
    } catch (error) {
      console.error('Error loading parking records:', error);
      this.parkingRecords = [];
      this.applyFiltersAndSort();
    } finally {
      this.isLoadingParkingRecords = false;
    }
  }

  async mergePaymentRecords(parkingRecords: ParkingRecord[]): Promise<ParkingRecord[]> {
    try {
      const recordsWithPaymentData = [...parkingRecords];
      
      // Get all session IDs from parking records
      const sessionIds = parkingRecords.map(record => record.id).filter(Boolean);
      
      if (sessionIds.length === 0) {
        return recordsWithPaymentData;
      }
      
      const paymentRecords = new Map();
      
      // Split session IDs into batches of 10 (Firestore 'in' query limit)
      const batchSize = 10;
      const batches = [];
      
      for (let i = 0; i < sessionIds.length; i += batchSize) {
        batches.push(sessionIds.slice(i, i + batchSize));
      }
      
      // Execute all batch queries in parallel
      const batchPromises = batches.map(async (batch) => {
        // Query single payments for this batch
        const singlePaymentQuery = firebase.firestore()
          .collection('online_payments')
          .where('parking_session_id', 'in', batch)
          .where('isPaid', '==', true);
        
        const singlePaymentSnapshot = await singlePaymentQuery.get();
        
        // Process single payment results
        singlePaymentSnapshot.forEach(doc => {
          const data = doc.data();
          const sessionId = data.parking_session_id;
          if (sessionId && !paymentRecords.has(sessionId)) {
            paymentRecords.set(sessionId, {
              payment_method: data.fundSource.type,
              updated_at: data.updated_at
            });
          }
        });
        
        // Query bulk payments for sessions not found in single payments
        const remainingSessions = batch.filter(sessionId => !paymentRecords.has(sessionId));
        
        if (remainingSessions.length > 0) {
          // For bulk payments, we need to query each session individually with array-contains
          const bulkPromises = remainingSessions.map(async (sessionId) => {
            try {
              const bulkPaymentQuery = await firebase.firestore()
                .collection('online_payments')
                .where('parking_session_ids', 'array-contains', sessionId)
                .where('isPaid', '==', true)
                .limit(1)
                .get();
              
              if (!bulkPaymentQuery.empty) {
                const data = bulkPaymentQuery.docs[0].data();
                paymentRecords.set(sessionId, {
                  payment_method: data.payment_method,
                  updated_at: data.updated_at
                });
              }
            } catch (error) {
              console.warn(`Error fetching bulk payment for session ${sessionId}:`, error);
            }
          });
          
          await Promise.all(bulkPromises);
        }
      });
      
      // Wait for all batch queries to complete
      await Promise.all(batchPromises);
      
      // Merge payment data into parking records
      recordsWithPaymentData.forEach((record, index) => {
        if (record.id && paymentRecords.has(record.id)) {
          const paymentData = paymentRecords.get(record.id);
          recordsWithPaymentData[index] = {
            ...record,
            payment_method: paymentData.payment_method
          };
        }
      });
      
      return recordsWithPaymentData;
    } catch (error) {
      console.error('Error merging payment records:', error);
      return parkingRecords; // Return original records if merging fails
    }
  }

  setupPaymentRecordsListener() {
    
    // Clean up existing listener if any
    if (this.paymentUnsubscriber) {
      this.paymentUnsubscriber();
    }
    
    this.isLoadingPayments = true;
    
    // Get user's vehicles for filtering (use all vehicles, not just verified)
    // This ensures payments made before verification are still visible
    const userVehicles = this.userVehicles || [];
    const userPlateNumbers = userVehicles.map(v => v.plate_number).filter(Boolean);
    
    // Get parking session IDs from current parking records
    const parkingSessionIds = this.parkingRecords.map(record => record.id).filter(Boolean);
    
    // Set up real-time listener for payment records
    try {
      // Create queries to get payments by parking_session_id and plate_number with isPaid = true
      const paymentQueries = [];
      
      // Query 1: Payments by parking_session_id (for specific parking sessions)
      if (parkingSessionIds.length > 0) {
        for (const sessionId of parkingSessionIds) {
          paymentQueries.push(
            firebase.firestore()
              .collection('online_payments')
              .where('parking_session_id', '==', sessionId)
              .where('isPaid', '==', true)
              .orderBy('updated_at', 'desc')
              .limit(50)
          );
        }
      }
      
      // Query 2: Payments by plate_number with isPaid = true (for additional coverage)
      if (userPlateNumbers.length > 0) {
        for (const plateNumber of userPlateNumbers) {
          paymentQueries.push(
            firebase.firestore()
              .collection('online_payments')
              .where('plate_number', '==', plateNumber)
              .where('isPaid', '==', true)
              .orderBy('updated_at', 'desc')
              .limit(50)
          );
        }
      }
      
      // Function to merge and deduplicate results from multiple queries
      const mergePaymentResults = (snapshots: any[]) => {
        const allPaymentRecords: PaymentRecord[] = [];
        const seenDocuments = new Set<string>();
        
        snapshots.forEach(snapshot => {
          snapshot.forEach(doc => {
            // Skip if we've already processed this document
            if (seenDocuments.has(doc.id)) {
              return;
            }
            seenDocuments.add(doc.id);
            
            const data = doc.data();
            
            // Only include successfully completed payments with isPaid = true
            if (data.isPaid === true) {
              
              // Check if this is a bulk payment
              const isBulkPayment = data.payment_type === 'bulk_unpaid_sessions' || 
                                   data.session_count > 1 || 
                                   (data.plate_numbers && Array.isArray(data.plate_numbers));
              
              if (isBulkPayment) {
                // Handle bulk payment
                const plateNumbers = data.plate_numbers || data.plateNumber || [];
                const hasUserVehicle = userVehicles.length === 0 || 
                                      plateNumbers.some(plate => userPlateNumbers.includes(plate));
                
                if (hasUserVehicle) {
                  allPaymentRecords.push({
                    id: doc.id,
                    amount: parseFloat(data.amount) || 0,
                    date_paid: this.formatPaymentDate(data.updated_at || data.updatedAt || data.created_at),
                    payment_method: data.payment_method || 'maya',
                    plate_number: plateNumbers.join(', ') || 'Multiple vehicles',
                    zone_name: data.zone_names || 'Multiple zones',
                    slot_name: data.slot_name,
                    status: data.status || data.payment_status || 'completed',
                    checkout_id: data.checkout_id,
                    transaction_reference: data.transaction_reference,
                    // Bulk payment specific fields
                    is_bulk_payment: true,
                    session_count: data.session_count || plateNumbers.length || 1,
                    plate_numbers: plateNumbers,
                    zone_names: data.zone_names || 'Multiple zones',
                    parking_session_ids: data.parking_session_ids || [],
                    sessions_detail: data.sessions_detail || [],
                    payment_type: data.payment_type || 'bulk_unpaid_sessions',
                    fundSource: data.fundSource || { type: 'maya' },
                    // Include metadata object
                    metadata: data.metadata || {
                      parking_session_id: data.parking_session_id,
                      payment_source: data.payment_source || 'dashboard',
                      plate_number: plateNumbers[0] || data.plate_number,
                      user_id: data.user_id || this.user?.uid,
                      zone_name: data.zone_names || data.zone_name
                    }
                  });
                }
              } else {
                // Handle single payment
                const plateNumber = data.plate_number || data.plateNumber || data.plate || 'Unknown';
                
                // If user has vehicles, only show payments for those vehicles
                if (userVehicles.length === 0 || userPlateNumbers.includes(plateNumber)) {
                  allPaymentRecords.push({
                    id: doc.id,
                    amount: parseFloat(data.amount) || 0,
                    date_paid: this.formatPaymentDate(data.updated_at || data.updatedAt || data.created_at),
                    payment_method: data.payment_method || 'maya',
                    plate_number: plateNumber,
                    zone_name: data.zone_name || '-',
                    slot_name: data.slot_name,
                    status: data.status || data.payment_status || 'completed',
                    checkout_id: data.checkout_id,
                    transaction_reference: data.transaction_reference,
                    is_bulk_payment: false,
                    fundSource: data.fundSource || { type: 'maya' },
                    // Include metadata object
                    metadata: data.metadata || {
                      parking_session_id: data.parking_session_id,
                      payment_source: data.payment_source || 'dashboard',
                      plate_number: plateNumber,
                      user_id: data.user_id || this.user?.uid,
                      zone_name: data.zone_name
                    }
                  });
                }
              }
            }
          });
        });
        
        return allPaymentRecords;
      };
      
      // Set up listeners for all queries
      const unsubscribers = [];
      let completedQueries = 0;
      const allSnapshots = [];
      
      paymentQueries.forEach((query, index) => {
        const unsubscriber = query.onSnapshot((snapshot) => {
          
          allSnapshots[index] = snapshot;
          completedQueries++;
          
          // Only process when all queries have returned results
          if (completedQueries === paymentQueries.length) {
            const allPaymentRecords = mergePaymentResults(allSnapshots);
            
            // Sort by date and limit to most recent 30 payments
            this.paymentRecords = allPaymentRecords
              .sort((a, b) => new Date(b.date_paid).getTime() - new Date(a.date_paid).getTime())
              .slice(0, 30);
              
            this.calculateStats();
            this.isLoadingPayments = false;
            this.cdr.detectChanges();
          }
        }, (error) => {
          console.error('Error in payments real-time listener:', error);
          
          // Fallback to non-ordered query if composite index is not available
          if (error.code === 'failed-precondition') {
            this.setupPaymentRecordsListenerFallback();
          } else {
            this.isLoadingPayments = false;
            this.cdr.detectChanges();
          }
        });
        
        unsubscribers.push(unsubscriber);
      });
      
      // Store all unsubscribers for cleanup
      this.paymentUnsubscriber = () => {
        unsubscribers.forEach(unsub => unsub());
      };
      
    } catch (error) {
      console.error('Error setting up payment records listener:', error);
      this.setupPaymentRecordsListenerFallback();
    }
  }
  
  setupPaymentRecordsListenerFallback() {
    
    // Get user's vehicles for filtering (use all vehicles, not just verified)
    // This ensures payments made before verification are still visible
    const userVehicles = this.userVehicles || [];
    const userPlateNumbers = userVehicles.map(v => v.plate_number).filter(Boolean);
    
    // Get parking session IDs from current parking records
    const parkingSessionIds = this.parkingRecords.map(record => record.id).filter(Boolean);
    
    // Create queries to get payments by parking_session_id and plate_number with isPaid = true
    const paymentQueries = [];
    
    // Query 1: Payments by parking_session_id (for specific parking sessions) - without ordering
    if (parkingSessionIds.length > 0) {
      for (const sessionId of parkingSessionIds) {
        paymentQueries.push(
          firebase.firestore()
            .collection('online_payments')
            .where('parking_session_id', '==', sessionId)
            .where('isPaid', '==', true)
            .limit(50)
        );
      }
    }
    
    // Query 2: Payments by plate_number with isPaid = true (for additional coverage) - without ordering
    if (userPlateNumbers.length > 0) {
      for (const plateNumber of userPlateNumbers) {
        paymentQueries.push(
          firebase.firestore()
            .collection('online_payments')
            .where('plate_number', '==', plateNumber)
            .where('isPaid', '==', true)
            .limit(50)
        );
      }
    }
    
    // Function to merge and deduplicate results from multiple queries
    const mergePaymentResults = (snapshots: any[]) => {
      const allPaymentRecords: PaymentRecord[] = [];
      const seenDocuments = new Set<string>();
      
      snapshots.forEach(snapshot => {
        snapshot.forEach(doc => {
          // Skip if we've already processed this document
          if (seenDocuments.has(doc.id)) {
            return;
          }
          seenDocuments.add(doc.id);
          
          const data = doc.data();
          
          // Only include successfully completed payments with isPaid = true
          if (data.isPaid === true) {
            
            // Check if this is a bulk payment
            const isBulkPayment = data.payment_type === 'bulk_unpaid_sessions' || 
                                 data.session_count > 1 || 
                                 (data.plate_numbers && Array.isArray(data.plate_numbers));
            
            if (isBulkPayment) {
              // Handle bulk payment
              const plateNumbers = data.plate_numbers || data.plateNumber || [];
              const hasUserVehicle = userVehicles.length === 0 || 
                                    plateNumbers.some(plate => userPlateNumbers.includes(plate));
              
              if (hasUserVehicle) {
                allPaymentRecords.push({
                  id: doc.id,
                  amount: parseFloat(data.amount) || 0,
                  date_paid: this.formatPaymentDate(data.updated_at || data.updatedAt || data.created_at),
                  payment_method: data.payment_method || 'maya',
                  plate_number: plateNumbers.join(', ') || 'Multiple vehicles',
                  zone_name: data.zone_names || 'Multiple zones',
                  slot_name: data.slot_name,
                  status: data.status || data.payment_status || 'completed',
                  checkout_id: data.checkout_id,
                  transaction_reference: data.transaction_reference,
                  // Bulk payment specific fields
                  is_bulk_payment: true,
                  session_count: data.session_count || plateNumbers.length || 1,
                  plate_numbers: plateNumbers,
                  zone_names: data.zone_names || 'Multiple zones',
                  parking_session_ids: data.parking_session_ids || [],
                  sessions_detail: data.sessions_detail || [],
                  payment_type: data.payment_type || 'bulk_unpaid_sessions',
                  fundSource: data.fundSource || { type: 'maya' },
                  // Include metadata object
                  metadata: data.metadata || {
                    parking_session_id: data.parking_session_id,
                    payment_source: data.payment_source || 'dashboard',
                    plate_number: plateNumbers[0] || data.plate_number,
                    user_id: data.user_id || this.user?.uid,
                    zone_name: data.zone_names || data.zone_name
                  }
                });
              }
            } else {
              // Handle single payment
              const plateNumber = data.plate_number || data.plateNumber || data.plate || 'Unknown';
              
              // If user has vehicles, only show payments for those vehicles
              if (userVehicles.length === 0 || userPlateNumbers.includes(plateNumber)) {
                allPaymentRecords.push({
                  id: doc.id,
                  amount: parseFloat(data.amount) || 0,
                  date_paid: this.formatPaymentDate(data.updated_at || data.updatedAt || data.created_at),
                  payment_method: data.payment_method || 'maya',
                  plate_number: plateNumber,
                  zone_name: data.zone_name || '-',
                  slot_name: data.slot_name,
                  status: data.status || data.payment_status || 'completed',
                  checkout_id: data.checkout_id,
                  transaction_reference: data.transaction_reference,
                  is_bulk_payment: false,
                  fundSource: data.fundSource || { type: 'maya' },
                  // Include metadata object
                  metadata: data.metadata || {
                    parking_session_id: data.parking_session_id,
                    payment_source: data.payment_source || 'dashboard',
                    plate_number: plateNumber,
                    user_id: data.user_id || this.user?.uid,
                    zone_name: data.zone_name
                  }
                });
              }
            }
          }
        });
      });
        
      return allPaymentRecords;
    };
      
      // Set up listeners for all queries
      const unsubscribers = [];
      let completedQueries = 0;
      const allSnapshots = [];
      
      paymentQueries.forEach((query, index) => {
        const unsubscriber = query.onSnapshot((snapshot) => {
          
          allSnapshots[index] = snapshot;
          completedQueries++;
          
          // Only process when all queries have returned results
          if (completedQueries === paymentQueries.length) {
            const allPaymentRecords = mergePaymentResults(allSnapshots);
            
            // Sort by date and limit to most recent 30 payments
            this.paymentRecords = allPaymentRecords
              .sort((a, b) => new Date(b.date_paid).getTime() - new Date(a.date_paid).getTime())
              .slice(0, 30);
              
            this.calculateStats();
            this.isLoadingPayments = false;
            this.cdr.detectChanges();
          }
        }, (error) => {
          console.error('Error in payments fallback listener:', error);
          this.isLoadingPayments = false;
          this.cdr.detectChanges();
        });
        
        unsubscribers.push(unsubscriber);
      });
      
      // Store all unsubscribers for cleanup
      this.paymentUnsubscriber = () => {
        unsubscribers.forEach(unsub => unsub());
      };
  }

  async loadPaymentRecords() {
    this.isLoadingPayments = true;
    try {
      const allPaymentRecords: PaymentRecord[] = [];
      
      // Get user's vehicles for filtering (use all vehicles, not just verified)
      const userVehicles = this.userVehicles || [];
      const userPlateNumbers = userVehicles.map(v => v.plate_number).filter(Boolean);
      
      // Get parking session IDs from current parking records
      const parkingSessionIds = this.parkingRecords.map(record => record.id).filter(Boolean);
      
      // Query 1: Get payments by parking_session_id with isPaid = true
      if (parkingSessionIds.length > 0) {
        for (const sessionId of parkingSessionIds) {
          try {
            const sessionQuerySnapshot = await firebase.firestore()
              .collection('online_payments')
              .where('parking_session_id', '==', sessionId)
              .where('isPaid', '==', true)
              .limit(50)
              .get();
            
            sessionQuerySnapshot.forEach(doc => {
              const data = doc.data();
              this.processPaymentRecord(doc, data, allPaymentRecords, userVehicles, userPlateNumbers);
            });
          } catch (error) {
            console.error(`Error loading payments for session ${sessionId}:`, error);
          }
        }
      }
      
      // Query 2: Get payments by plate_number with isPaid = true (for additional coverage)
      if (userPlateNumbers.length > 0) {
        for (const plateNumber of userPlateNumbers) {
          try {
            const plateQuerySnapshot = await firebase.firestore()
              .collection('online_payments')
              .where('plate_number', '==', plateNumber)
              .where('isPaid', '==', true)
              .limit(50)
              .get();
            
            plateQuerySnapshot.forEach(doc => {
              const data = doc.data();
              this.processPaymentRecord(doc, data, allPaymentRecords, userVehicles, userPlateNumbers);
            });
          } catch (error) {
            console.error(`Error loading payments for plate ${plateNumber}:`, error);
          }
        }
      }
      
      // Remove duplicates based on document ID
      const uniquePaymentRecords = allPaymentRecords.filter((record, index, self) => 
        index === self.findIndex(r => r.id === record.id)
      );
      
      // Sort by date and limit to most recent 30 payments
      this.paymentRecords = uniquePaymentRecords
        .sort((a, b) => new Date(b.date_paid).getTime() - new Date(a.date_paid).getTime())
        .slice(0, 30);
        
    } catch (error) {
      console.error('Error loading payment records:', error);
      this.paymentRecords = [];
    } finally {
      this.isLoadingPayments = false;
    }
  }

  private processPaymentRecord(doc: any, data: any, allPaymentRecords: PaymentRecord[], userVehicles: UserVehicle[], userPlateNumbers: string[]) {
    // Only include successfully completed payments with isPaid = true
    if (data.isPaid === true) {
      // Check if this is a bulk payment
      const isBulkPayment = data.payment_type === 'bulk_unpaid_sessions' || 
                           data.session_count > 1 || 
                           (data.plate_numbers && Array.isArray(data.plate_numbers));
      
      if (isBulkPayment) {
        // Handle bulk payment
        const plateNumbers = data.plate_numbers || data.plateNumber || [];
        const hasUserVehicle = userVehicles.length === 0 || 
                              plateNumbers.some(plate => userPlateNumbers.includes(plate));
        
        if (hasUserVehicle) {
          allPaymentRecords.push({
            id: doc.id,
            amount: parseFloat(data.amount) || 0,
            date_paid: this.formatPaymentDate(data.updated_at || data.updatedAt || data.created_at),
            payment_method: data.payment_method || 'maya',
            plate_number: plateNumbers.join(', ') || 'Multiple vehicles',
            zone_name: data.zone_names || 'Multiple zones',
            slot_name: data.slot_name,
            status: data.status || data.payment_status || 'completed',
            checkout_id: data.checkout_id,
            transaction_reference: data.transaction_reference,
            // Bulk payment specific fields
            is_bulk_payment: true,
            session_count: data.session_count || plateNumbers.length || 1,
            plate_numbers: plateNumbers,
            zone_names: data.zone_names || 'Multiple zones',
            parking_session_ids: data.parking_session_ids || [],
            sessions_detail: data.sessions_detail || [],
            payment_type: data.payment_type || 'bulk_unpaid_sessions',
            fundSource: data.fundSource || { type: 'maya' },
            // Include metadata object
            metadata: data.metadata || {
              parking_session_id: data.parking_session_id,
              payment_source: data.payment_source || 'dashboard',
              plate_number: plateNumbers[0] || data.plate_number,
              user_id: data.user_id || this.user?.uid,
              zone_name: data.zone_names || data.zone_name
            }
          });
        }
      } else {
        // Handle single payment
        const plateNumber = data.plate_number || data.plateNumber || data.plate || 'Unknown';
        
        // If user has vehicles, only show payments for those vehicles
        if (userVehicles.length === 0 || userPlateNumbers.includes(plateNumber)) {
          allPaymentRecords.push({
            id: doc.id,
            amount: parseFloat(data.amount) || 0,
            date_paid: this.formatPaymentDate(data.updated_at || data.updatedAt || data.created_at),
            payment_method: data.payment_method || 'maya',
            plate_number: plateNumber,
            zone_name: data.zone_name || '-',
            slot_name: data.slot_name,
            status: data.status || data.payment_status || 'completed',
            checkout_id: data.checkout_id,
            transaction_reference: data.transaction_reference,
            is_bulk_payment: false,
            fundSource: data.fundSource || { type: 'maya' },
            // Include metadata object
            metadata: data.metadata || {
              parking_session_id: data.parking_session_id,
              payment_source: data.payment_source || 'dashboard',
              plate_number: plateNumber,
              user_id: data.user_id || this.user?.uid,
              zone_name: data.zone_name
            }
          });
        }
      }
    }
  }

  updateGeotagPhotosFromParkingRecords() {
    this.isLoadingPhotos = true;
    try {
      const geotagPhotos: GeotagPhoto[] = [];
      
      // Extract geotag data from parking records
      this.parkingRecords.forEach(record => {
        if (record.geotag) {
          geotagPhotos.push({
            id: record.id,
            geotagImage: record.geotag.geotagImage,
            plateNumber: record.plate_number,
            address: record.geotag.address || 'Location not available',
            lat: record.geotag.lat || record.geotag.latitude || 0,
            lng: record.geotag.lng || record.geotag.longitude || 0,
            timestamp: record.geotag.timestamp || record.time_in,
            accuracy: record.geotag.accuracy
          });
        }
      });
      
      // Sort by timestamp descending
      this.geotagPhotos = geotagPhotos.sort((a, b) => {
        const dateA = a.timestamp?.seconds ? new Date(a.timestamp.seconds * 1000).getTime() : 
                     a.timestamp ? new Date(a.timestamp).getTime() : 0;
        const dateB = b.timestamp?.seconds ? new Date(b.timestamp.seconds * 1000).getTime() : 
                     b.timestamp ? new Date(b.timestamp).getTime() : 0;
        return dateB - dateA;
      });

    } catch (error) {
      console.error('Error updating geotag photos from parking records:', error);
      this.geotagPhotos = [];
    } finally {
      this.isLoadingPhotos = false;
    }
  }

  async loadViolations() {
    this.isLoadingViolations = true;
    try {
      // Mock data for now
      this.violations = [];
    } catch (error) {
      console.error('Error loading violations:', error);
      this.violations = [];
    } finally {
      this.isLoadingViolations = false;
    }
  }

  calculateStats() {
    this.totalParkingSessions = this.parkingRecords.length;
    this.unpaidRecords = this.parkingRecords.filter(record => this.shouldShowPayNowButton(record) && record.payment_status !== 'Paid');
    this.unpaidSessions = this.unpaidRecords.length;
    this.totalPaidAmount = this.paymentRecords.reduce((sum, payment) => sum + (payment.amount || 0), 0);
    this.activeViolations = this.violations.filter(violation => violation.status === 'active').length;
  }

  async calculateTotalUnpaidAmount(): Promise<number> {
    return this.paymayaPaymentService.calculateTotalUnpaidAmount(this.unpaidRecords);
  }

  private shouldRedirectToVehicleRegistration(): boolean {
    // Check if user has any registered vehicles (regardless of verification status)
    // Only redirect if user has NO vehicles at all (first time users)
    return this.userVehicles.length === 0;
  }

  formatFirebaseTimestamp(timestamp: any): string {
    if (!timestamp) return '-';
    
    try {
      let date: Date;
      if (timestamp._seconds) {
        // Handle Firebase timestamp with _seconds property
        date = new Date(timestamp._seconds * 1000);
      } else if (timestamp.seconds) {
        // Handle Firebase timestamp with seconds property
        date = new Date(timestamp.seconds * 1000);
      } else if (timestamp.toDate) {
        // Handle Firebase Timestamp object with toDate method
        date = timestamp.toDate();
      } else {
        // Handle string or other formats
        date = new Date(timestamp);
      }
      
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch {
      return '-';
    }
  }

  formatPaymentDate(timestamp: any): string {
    if (!timestamp) return '-';
    
    try {
      let date: Date;
      if (timestamp.seconds) {
        date = new Date(timestamp.seconds * 1000);
      } else if (timestamp.toDate) {
        date = timestamp.toDate();
      } else {
        date = new Date(timestamp);
      }
      
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch {
      return '-';
    }
  }

  setActiveTab(tab: string) {
    this.activeTab = tab;
  }

  handleUnpaidSessionClick() {
    
    if (this.unpaidSessions > 0) {
      // Switch to parking tab first
      this.setActiveTab('parking');
      
      // Get unpaid records dynamically in case unpaidRecords array wasn't properly set
      const currentUnpaidRecords = this.parkingRecords.filter(record => this.shouldShowPayNowButton(record));
      
      if (currentUnpaidRecords.length > 0) {
        // Wait a bit for the tab to switch, then open the modal for all unpaid records
        setTimeout(async () => {
          try {
            await this.openPaymentModalForAllUnpaid();
          } catch (error) {
            console.error('Error opening payment modal:', error);
          }
        }, 200);
      } else {
        // Refresh unpaid records array
        this.calculateStats();
      }
    } else {
      console.log('No unpaid sessions to handle');
    }
  }


  exitAdminView(): void {
    // Clean up temporary admin access data
    sessionStorage.removeItem('admin_user_access');
    localStorage.removeItem('temp_user_for_admin');
    localStorage.removeItem('parkbot_user_session');

    // Try to close the tab, if that fails, redirect to admin panel
    try {
      window.close();
      // If window.close() doesn't work (when not opened via script), redirect
      setTimeout(() => {
        window.location.href = '/admin/myparking-access';
      }, 500);
    } catch (error) {
      window.location.href = '/admin/myparking-access';
    }
  }

  async logout() {
    try {
      // Normal logout flow only (admin view exit is handled separately)
      // Clear local session
      this.localSessionService.clearSession();

      // Sign out from Firebase Auth if signed in
      try {
        await this.authService.signOut();
      } catch (authError) {
        // Ignore auth errors during logout
        console.log('Auth sign out not needed or failed:', authError);
      }

      this.router.navigate([this.routeHelper.getRoutes().auth]);
    } catch (error) {
      console.error('Logout error:', error);
      // Force redirect even if logout fails
      this.localSessionService.clearSession();
      this.router.navigate([this.routeHelper.getRoutes().auth]);
    }
  }

  getStatusBadgeClass(status: string): string {
    switch (status?.toLowerCase()) {
      case 'paid': return 'bg-green-100 text-green-800';
      case 'unpaid': return 'bg-red-100 text-red-800';
      case 'active': return 'bg-orange-100 text-orange-800';
      case 'resolved': return 'bg-gray-100 text-gray-800';
      case 'processing': return 'bg-yellow-100 text-yellow-800';
      case 'failed': return 'bg-red-100 text-red-800';
      case 'cancelled': return 'bg-gray-100 text-gray-800';
      case 'expired': return 'bg-gray-100 text-gray-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  }

  getPaymentStatusText(paid: boolean, paymentStatus?: string): string {
    if (paid) return 'Paid';
    if (paymentStatus) return paymentStatus;
    return 'Unpaid';
  }

  getRecordStatus(paid: boolean, paymentStatus?: string, sessionStatus?: number): string {
    if (paid || paymentStatus === 'Paid') return 'paid';
    if (paymentStatus === 'Failed') return 'failed';
    if (paymentStatus === 'Cancelled') return 'cancelled';
    if (paymentStatus === 'Expired') return 'expired';
    if (sessionStatus === 1) return 'active';
    return 'unpaid';
  }

  shouldShowPayNowButton(record: ParkingRecord): boolean {
    return this.paymayaPaymentService.shouldShowPayNowButton(record);
  }

  getEffectiveEndTime(record: ParkingRecord): string {
    return this.paymayaPaymentService.getEffectiveEndTime(record);
  }

  getEffectiveEndTimeForSession(session: any): string {
    // If there's auto_end_time and no time_out, use auto_end_time (format if it's an object)
    if (session.auto_end_time && !session.time_out) {
      return this.formatFirebaseTimestamp(session.auto_end_time);
    }
    // Otherwise use time_out or 'Active'
    return session.time_out || 'Active';
  }

  // Search, Filter, and Sort Methods
  onSearchChange(): void {
    this.applyFiltersAndSort();
  }

  onFilterChange(): void {
    this.applyFiltersAndSort();
  }

  onDateRangeChange(): void {
    // Reset custom dates when switching away from custom
    if (this.dateRangeFilter !== 'custom') {
      this.customStartDate = '';
      this.customEndDate = '';
    }
    this.applyFiltersAndSort();
  }

  onCustomDateChange(): void {
    this.applyFiltersAndSort();
  }

  onSortChange(): void {
    this.applyFiltersAndSort();
  }

  clearSearch(): void {
    this.searchQuery = '';
    this.applyFiltersAndSort();
  }

  clearAllFilters(): void {
    this.searchQuery = '';
    this.paymentStatusFilter = 'all';
    this.paymentMethodFilter = 'all';
    this.dateRangeFilter = 'all';
    this.sortOption = 'status_date';
    this.customStartDate = '';
    this.customEndDate = '';
    this.applyFiltersAndSort();
  }

  hasActiveFilters(): boolean {
    return this.searchQuery !== '' || 
           this.paymentStatusFilter !== 'all' || 
           this.paymentMethodFilter !== 'all' ||
           this.dateRangeFilter !== 'all' ||
           this.sortOption !== 'status_date' ||
           this.customStartDate !== '' ||
           this.customEndDate !== '';
  }

  getDateRangeLabel(dateRange: string): string {
    switch (dateRange) {
      case 'today': return 'Today';
      case 'week': return 'This Week';
      case 'month': return 'This Month';
      case 'last30': return 'Last 30 Days';
      case 'custom': 
        if (this.customStartDate && this.customEndDate) {
          return `${this.customStartDate} to ${this.customEndDate}`;
        } else if (this.customStartDate) {
          return `From ${this.customStartDate}`;
        } else if (this.customEndDate) {
          return `Until ${this.customEndDate}`;
        } else {
          return 'Custom Range';
        }
      default: return 'All Time';
    }
  }

  applyFiltersAndSort(): void {
    let filtered = [...this.parkingRecords];

    // Apply search filter
    if (this.searchQuery) {
      const query = this.searchQuery.toLowerCase();
      filtered = filtered.filter(record =>
        record.plate_number?.toLowerCase().includes(query) ||
        record.zone_name?.toLowerCase().includes(query) ||
        record.slot_name?.toLowerCase().includes(query) ||
        record.processedBy?.toLowerCase().includes(query)
      );
    }

    // Apply payment status filter
    if (this.paymentStatusFilter !== 'all') {
      filtered = filtered.filter(record => {
        switch (this.paymentStatusFilter) {
          case 'unpaid':
            return this.shouldShowPayNowButton(record) && !record.paid;
          case 'paid':
            return record.paid;
          case 'completed':
            return !this.shouldShowPayNowButton(record) && !record.paid;
          default:
            return true;
        }
      });
    }

    // Apply payment method filter
    if (this.paymentMethodFilter !== 'all') {
      filtered = filtered.filter(record => {
        const paymentMethod = (record.payment_method || '').toLowerCase();
        switch (this.paymentMethodFilter) {
          case 'cash':
            return !paymentMethod.includes('paymaya') && !paymentMethod.includes('gcash');
          case 'online':
            return paymentMethod.includes('online') || paymentMethod.includes('paymaya') || paymentMethod.includes('gcash');
          case 'paymaya':
            return paymentMethod.includes('paymaya');
          case 'gcash':
            return paymentMethod.includes('gcash');
          case 'card':
            return paymentMethod.includes('card') || paymentMethod.includes('credit') || paymentMethod.includes('debit');
          case 'bank':
            return paymentMethod.includes('bank') || paymentMethod.includes('transfer');
          default:
            return true;
        }
      });
    }

    // Apply date range filter
    if (this.dateRangeFilter !== 'all') {
      const now = new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      
      filtered = filtered.filter(record => {
        const recordDate = new Date(record.time_in);
        
        switch (this.dateRangeFilter) {
          case 'today':
            return recordDate >= today;
          case 'week':
            const weekAgo = new Date(today);
            weekAgo.setDate(weekAgo.getDate() - 7);
            return recordDate >= weekAgo;
          case 'month':
            const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);
            return recordDate >= monthStart;
          case 'last30':
            const thirtyDaysAgo = new Date(today);
            thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
            return recordDate >= thirtyDaysAgo;
          case 'custom':
            let isInRange = true;
            if (this.customStartDate) {
              const startDate = new Date(this.customStartDate);
              startDate.setHours(0, 0, 0, 0);
              isInRange = isInRange && recordDate >= startDate;
            }
            if (this.customEndDate) {
              const endDate = new Date(this.customEndDate);
              endDate.setHours(23, 59, 59, 999);
              isInRange = isInRange && recordDate <= endDate;
            }
            return isInRange;
          default:
            return true;
        }
      });
    }

    // Apply sorting
    filtered.sort((a, b) => {
      switch (this.sortOption) {
        case 'status_date':
          // First sort by payment status - unpaid records first
          const aIsUnpaid = this.shouldShowPayNowButton(a) && !a.paid;
          const bIsUnpaid = this.shouldShowPayNowButton(b) && !b.paid;
          
          if (aIsUnpaid && !bIsUnpaid) return -1;
          if (!aIsUnpaid && bIsUnpaid) return 1;
          
          // If both have same payment status, sort by time_in descending
          const dateA = new Date(a.time_in || 0).getTime();
          const dateB = new Date(b.time_in || 0).getTime();
          return dateB - dateA;
          
        case 'date_desc':
          return new Date(b.time_in || 0).getTime() - new Date(a.time_in || 0).getTime();
          
        case 'date_asc':
          return new Date(a.time_in || 0).getTime() - new Date(b.time_in || 0).getTime();
          
        case 'amount_desc':
          const amountA = a.amount_due || a.amount_paid || 0;
          const amountB = b.amount_due || b.amount_paid || 0;
          return amountB - amountA;
          
        case 'amount_asc':
          const amountA2 = a.amount_due || a.amount_paid || 0;
          const amountB2 = b.amount_due || b.amount_paid || 0;
          return amountA2 - amountB2;
          
        case 'plate':
          return (a.plate_number || '').localeCompare(b.plate_number || '');
          
        case 'zone':
          return (a.zone_name || '').localeCompare(b.zone_name || '');
          
        default:
          return 0;
      }
    });

    this.filteredParkingRecords = filtered;
  }

  // Vehicle management methods
  showAddVehicleForm() {
    this.showVehicleForm = true;
    this.currentStep = 1;
    this.declarationAccepted = false;
    this.vehicleError = '';
  }

  onVehicleRegistrationSuccess(vehicle: UserVehicle) {
    // Add the new vehicle to the local array
    this.userVehicles.unshift({
      ...vehicle,
      date_registered: new Date(vehicle.date_registered || Date.now())
    });
    
    // Close the wizard
    this.showVehicleForm = false;
    
    // Switch to vehicles tab to show the newly registered vehicle
    if (this.demoMode) {
      this.setActiveTab('vehicles');
      
      // Show success message
      setTimeout(() => {
        alert('Vehicle registered successfully! You can now use this vehicle for parking.');
      }, 500);
    }
  }

  onVehicleRegistrationError(error: string) {
    this.vehicleError = error;
    console.error('Vehicle registration error:', error);
  }

  cancelAddVehicle() {
    this.showVehicleForm = false;
    this.currentStep = 1;
    this.declarationAccepted = false;
    this.newVehicle = {
      plate_number: '',
      vehicle_type: '',
      vehicle_model: '',
      vehicle_color: '',
      vin_number: '',
      owner_full_name: '',
      owner_contact_number: '',
      owner_email: '',
      owner_address: '',
      driver_license_number: '',
      license_expiry_date: '',
      drivers_license: []
    };
    this.documentPreviews = {};
    this.vehicleError = '';
  }

  cleanVehiclePlateNumber(event: any) {
    // Remove all special characters, spaces, and keep only letters and numbers
    const cleaned = event.target.value.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
    this.newVehicle.plate_number = cleaned;
    
    // Clear errors when user starts typing
    if (this.vehicleError && this.vehicleError.includes('plate')) {
      this.vehicleError = '';
    }
  }

  // Additional validation methods
  validateEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  validatePhoneNumber(phone: string): boolean {
    // Philippine phone number validation (09XXXXXXXXX or +639XXXXXXXXX)
    const phoneRegex = /^(\+639|09)\d{9}$/;
    return phoneRegex.test(phone);
  }

  validateLicenseNumber(license: string): boolean {
    // Philippine license format validation (flexible)
    return license && license.length >= 8 && license.length <= 15;
  }

  validateLicenseExpiry(date: string): boolean {
    if (!date) return false;
    const expiryDate = new Date(date);
    const today = new Date();
    return expiryDate > today;
  }

  getValidationErrors(): string[] {
    const errors: string[] = [];
    
    switch (this.currentStep) {
      case 1:
        if (!this.newVehicle.plate_number) {
          errors.push('Plate number is required');
        } else if (this.newVehicle.plate_number.length < 6) {
          errors.push('Plate number must be at least 6 characters');
        }
        
        if (!this.newVehicle.vehicle_type) {
          errors.push('Vehicle type is required');
        }
        
        if (!this.newVehicle.vehicle_model) {
          errors.push('Vehicle model is required');
        }
        
        if (!this.newVehicle.vehicle_color) {
          errors.push('Vehicle color is required');
        }
        break;
        
      case 2:
        if (!this.newVehicle.owner_full_name) {
          errors.push('Owner full name is required');
        }
        
        if (!this.newVehicle.owner_contact_number) {
          errors.push('Contact number is required');
        } else if (!this.validatePhoneNumber(this.newVehicle.owner_contact_number)) {
          errors.push('Please enter a valid Philippine phone number (09XXXXXXXXX)');
        }
        
        if (!this.newVehicle.owner_email) {
          errors.push('Email address is required');
        } else if (!this.validateEmail(this.newVehicle.owner_email)) {
          errors.push('Please enter a valid email address');
        }
        
        if (!this.newVehicle.owner_address) {
          errors.push('Owner address is required');
        }
        break;
        
      case 3:
        if (!this.newVehicle.driver_license_number) {
          errors.push('Driver license number is required');
        } else if (!this.validateLicenseNumber(this.newVehicle.driver_license_number)) {
          errors.push('Please enter a valid license number');
        }
        
        if (!this.newVehicle.license_expiry_date) {
          errors.push('License expiry date is required');
        } else if (!this.validateLicenseExpiry(this.newVehicle.license_expiry_date)) {
          errors.push('License has expired or expiry date is invalid');
        }
        break;
        
      case 4:
        if (!this.newVehicle.cr_document) {
          errors.push('Certificate of Registration (CR) is required');
        }
        
        if (!this.newVehicle.or_document) {
          errors.push('Official Receipt (OR) is required');
        }
        
        if (!this.newVehicle.government_id) {
          errors.push('Valid Government ID is required');
        }
        
        if (!this.newVehicle.drivers_license || this.newVehicle.drivers_license.length === 0) {
          errors.push('Driver\'s License (front & back) is required');
        }
        break;
        
      case 5:
        if (!this.declarationAccepted) {
          errors.push('You must accept the declaration to proceed');
        }
        break;
    }
    
    return errors;
  }

  showValidationErrors() {
    const errors = this.getValidationErrors();
    if (errors.length > 0) {
      this.vehicleError = errors.join('. ');
      return false;
    }
    this.vehicleError = '';
    return true;
  }

  // Multi-step form navigation methods
  getStepIndicatorClass(stepNumber: number): string {
    if (this.currentStep > stepNumber) {
      return 'bg-gradient-to-r from-green-500 to-emerald-600 text-white border-green-500 shadow-lg transform scale-105'; // Completed step
    } else if (this.currentStep === stepNumber) {
      return 'bg-gradient-to-r from-blue-500 to-indigo-600 text-white border-blue-500 shadow-lg transform scale-110'; // Current step
    } else {
      return 'bg-white text-gray-400 border-gray-300 shadow-sm'; // Future step
    }
  }

  canProceedToNext(): boolean {
    switch (this.currentStep) {
      case 1:
        return !!(this.newVehicle.plate_number && 
                 this.newVehicle.vehicle_type && 
                 this.newVehicle.vehicle_model && 
                 this.newVehicle.vehicle_color);
      case 2:
        return !!(this.newVehicle.owner_full_name && 
                 this.newVehicle.owner_contact_number && 
                 this.newVehicle.owner_email && 
                 this.newVehicle.owner_address);
      case 3:
        return !!(this.newVehicle.driver_license_number && 
                 this.newVehicle.license_expiry_date);
      case 4:
        return !!(this.newVehicle.cr_document && 
                 this.newVehicle.or_document && 
                 this.newVehicle.government_id && 
                 this.newVehicle.drivers_license && 
                 this.newVehicle.drivers_license.length > 0);
      case 5:
        return this.declarationAccepted;
      default:
        return false;
    }
  }

  nextStep() {
    if (this.showValidationErrors()) {
      if (this.currentStep < this.registrationSteps.length) {
        this.currentStep++;
      }
    }
  }

  previousStep() {
    if (this.currentStep > 1) {
      this.currentStep--;
      this.vehicleError = ''; // Clear errors when going back
    }
  }

  handleStepSubmit() {
    if (this.currentStep === 5) {
      // Final submission - validate all previous steps
      if (this.showValidationErrors()) {
        this.registerVehicle();
      }
    } else {
      // Move to next step with validation
      this.nextStep();
    }
  }

  handleFileUpload(event: any, documentType: string) {
    const files = event.target.files;
    if (!files || files.length === 0) return;

    // Clear any previous errors
    this.vehicleError = '';

    if (documentType === 'drivers_license') {
      // Handle multiple files for driver's license
      const validFiles: File[] = [];
      const previews: string[] = [];

      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        
        // Validate file
        if (this.validateFile(file)) {
          validFiles.push(file);
          this.generatePreview(file).then(preview => {
            previews.push(preview);
          });
        }
      }

      if (validFiles.length > 0) {
        this.newVehicle.drivers_license = validFiles;
        Promise.all(validFiles.map(file => this.generatePreview(file))).then(previewUrls => {
          this.documentPreviews[documentType] = previewUrls;
        });
      }
    } else {
      // Handle single file
      const file = files[0];
      
      if (!this.validateFile(file)) {
        return;
      }

      // Generate previewswal
      this.generatePreview(file).then(previewUrl => {
        this.documentPreviews[documentType] = previewUrl;
      });

      // Store file based on document type
      switch (documentType) {
        case 'cr_document':
          this.newVehicle.cr_document = file;
          break;
        case 'or_document':
          this.newVehicle.or_document = file;
          break;
        case 'government_id':
          this.newVehicle.government_id = file;
          break;
        case 'insurance_document':
          this.newVehicle.insurance_document = file;
          break;
      }
    }
  }

  private validateFile(file: File): boolean {
    // Validate file size (5MB max)
    const maxSize = 5 * 1024 * 1024; // 5MB
    if (file.size > maxSize) {
      this.vehicleError = 'File size must be less than 5MB';
      return false;
    }

    // Validate file type
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];
    if (!allowedTypes.includes(file.type)) {
      this.vehicleError = 'Only JPG, PNG, and PDF files are allowed';
      return false;
    }

    return true;
  }

  private generatePreview(file: File): Promise<string> {
    return new Promise((resolve) => {
      if (file.type === 'application/pdf') {
        // For PDF files, use a PDF icon
        resolve('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MTIgNTEyIj48cGF0aCBkPSJNMzIwIDBoLTI1NkMzNy41IDAgMTcuMiAyMC4zIDE3LjIgNDUuM3Y0MjEuNEMxNy4yIDQ5MS43IDM3LjUgNTEyIDY0IDUxMmgzODRjMjYuNSAwIDQ4LTIxLjUgNDgtNDhWMTQ0TDMyMCAwem0wIDEyOGgxMjhMMzIwIDE0NFYxMjh6Ii8+PC9zdmc+');
      } else {
        // For image files, create a thumbnail
        const reader = new FileReader();
        reader.onload = (e) => {
          resolve(e.target?.result as string);
        };
        reader.readAsDataURL(file);
      }
    });
  }

  removeDocument(documentType: string, index?: number) {
    if (documentType === 'drivers_license' && typeof index === 'number') {
      // Remove specific driver's license file
      if (this.newVehicle.drivers_license) {
        this.newVehicle.drivers_license.splice(index, 1);
        const previews = this.documentPreviews[documentType] as string[];
        if (previews) {
          previews.splice(index, 1);
          this.documentPreviews[documentType] = previews;
        }
        if (this.newVehicle.drivers_license.length === 0) {
          delete this.newVehicle.drivers_license;
          delete this.documentPreviews[documentType];
        }
      }
    } else {
      // Remove single document
      switch (documentType) {
        case 'cr_document':
          delete this.newVehicle.cr_document;
          break;
        case 'or_document':
          delete this.newVehicle.or_document;
          break;
        case 'government_id':
          delete this.newVehicle.government_id;
          break;
        case 'insurance_document':
          delete this.newVehicle.insurance_document;
          break;
      }
      delete this.documentPreviews[documentType];
    }
    
    // Clear validation errors when removing documents
    this.vehicleError = '';
  }

  getUploadedDocumentCount(): number {
    let count = 0;
    
    // Count required documents
    if (this.documentPreviews['cr_document']) count++;
    if (this.documentPreviews['or_document']) count++;
    if (this.documentPreviews['government_id']) count++;
    if (this.documentPreviews['drivers_license'] && (this.documentPreviews['drivers_license'] as string[])?.length > 0) {
      count += (this.documentPreviews['drivers_license'] as string[]).length;
    }
    
    // Count optional documents
    if (this.documentPreviews['insurance_document']) count++;
    
    return count;
  }

  // Helper methods for template conditions
  hasDriversLicenseUploads(): boolean {
    return this.documentPreviews['drivers_license'] && 
           (this.documentPreviews['drivers_license'] as string[])?.length > 0;
  }

  getDriversLicensePreviews(): string[] {
    return (this.documentPreviews['drivers_license'] as string[]) || [];
  }

  async registerVehicle() {
    // Re-validate authentication before allowing vehicle registration
    const isAuthenticated = await this.validateUserAuthentication();
    if (!isAuthenticated) {
      return;
    }

    if (!this.canProceedToNext()) {
      this.vehicleError = 'Please complete all required fields and upload all required documents.';
      return;
    }

    this.isSubmittingVehicle = true;
    this.vehicleError = '';

    try {
      // Upload documents first (if any)
      const uploadedDocuments = await this.uploadVehicleDocuments();

      // Use Cloud Function to create vehicle with enhanced data
      const response: any = await this.http.post(`${environment.apiBaseUrl}/createUserVehicle`, {
        owner_id: this.user.uid,
        plateNumber: this.newVehicle.plate_number,
        vehicleType: this.newVehicle.vehicle_type,
        vehicleModel: this.newVehicle.vehicle_model,
        vehicleColor: this.newVehicle.vehicle_color,
        vinNumber: this.newVehicle.vin_number,
        ownerFullName: this.newVehicle.owner_full_name,
        ownerContactNumber: this.newVehicle.owner_contact_number,
        ownerEmail: this.newVehicle.owner_email,
        ownerAddress: this.newVehicle.owner_address,
        driverLicenseNumber: this.newVehicle.driver_license_number,
        licenseExpiryDate: this.newVehicle.license_expiry_date,
        uploadedDocuments: uploadedDocuments
      }).toPromise();

      if (response.success) {

        // Move to success step
        this.currentStep = 6;
        
      } else {
        this.vehicleError = response.message || 'Failed to register vehicle.';
      }
      
    } catch (error) {
      console.error('Error registering vehicle:', error);
      if (error.status === 409) {
        this.vehicleError = error.error.message || 'This plate number is already registered.';
      } else {
        this.vehicleError = 'Failed to register vehicle. Please try again.';
      }
    } finally {
      this.isSubmittingVehicle = false;
    }
  }

  private async uploadVehicleDocuments(): Promise<any> {
    const uploadedDocuments: any = {};
    
    try {
      if (this.newVehicle.cr_document) {
        if (this.newVehicle.cr_document instanceof File) {
          const crUrl = await this.uploadFileToStorage(this.newVehicle.cr_document, 'cr_documents');
          uploadedDocuments.cr_document = crUrl;
        } else {
          // It's already a URL string
          uploadedDocuments.cr_document = this.newVehicle.cr_document;
        }
      }
      
      if (this.newVehicle.or_document) {
        if (this.newVehicle.or_document instanceof File) {
          const orUrl = await this.uploadFileToStorage(this.newVehicle.or_document, 'or_documents');
          uploadedDocuments.or_document = orUrl;
        } else {
          // It's already a URL string
          uploadedDocuments.or_document = this.newVehicle.or_document;
        }
      }
      
      if (this.newVehicle.government_id) {
        if (this.newVehicle.government_id instanceof File) {
          const govIdUrl = await this.uploadFileToStorage(this.newVehicle.government_id, 'government_ids');
          uploadedDocuments.government_id = govIdUrl;
        } else {
          // It's already a URL string
          uploadedDocuments.government_id = this.newVehicle.government_id;
        }
      }
      
      if (this.newVehicle.drivers_license && this.newVehicle.drivers_license.length > 0) {
        const licenseUrls = [];
        for (let i = 0; i < this.newVehicle.drivers_license.length; i++) {
          const license = this.newVehicle.drivers_license[i];
          if (license instanceof File) {
            const licenseUrl = await this.uploadFileToStorage(license, 'drivers_licenses');
            licenseUrls.push(licenseUrl);
          } else {
            // It's already a URL string
            licenseUrls.push(license);
          }
        }
        uploadedDocuments.drivers_license = licenseUrls;
      }
      
      if (this.newVehicle.insurance_document) {
        if (this.newVehicle.insurance_document instanceof File) {
          const insuranceUrl = await this.uploadFileToStorage(this.newVehicle.insurance_document, 'insurance_documents');
          uploadedDocuments.insurance_document = insuranceUrl;
        } else {
          // It's already a URL string
          uploadedDocuments.insurance_document = this.newVehicle.insurance_document;
        }
      }
      
      return uploadedDocuments;
    } catch (error) {
      console.error('Error uploading documents:', error);
      throw new Error('Failed to upload documents. Please try again.');
    }
  }

  private async uploadFileToStorage(file: File, folder: string): Promise<string> {
    const storageRef = firebase.storage().ref();
    const fileRef = storageRef.child(`vehicle_documents/${this.user.uid}/${folder}/${Date.now()}_${file.name}`);
    
    const snapshot = await fileRef.put(file);
    return await snapshot.ref.getDownloadURL();
  }

  async resubmitVehicle(vehicle: UserVehicle) {
    try {
      await firebase.firestore()
        .collection('vehicles')
        .doc(vehicle.id!)
        .update({
          verification_status: 'pending',
          rejection_reason: firebase.firestore.FieldValue.delete()
        });

      // Update local state
      const index = this.userVehicles.findIndex(v => v.id === vehicle.id);
      if (index !== -1) {
        this.userVehicles[index].verification_status = 'pending';
        delete this.userVehicles[index].rejection_reason;
      }
      
    } catch (error) {
      console.error('Error resubmitting vehicle:', error);
    }
  }

  getVehicleStatusBadgeClass(status: string | undefined): string {
    switch (status) {
      case 'verified': return 'bg-green-100 text-green-800';
      case 'pending': return 'bg-yellow-100 text-yellow-800';
      case 'rejected': return 'bg-red-100 text-red-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  }

  getVehicleStatusText(status: string | undefined): string {
    switch (status) {
      case 'verified': return 'Verified';
      case 'pending': return 'Pending';
      case 'rejected': return 'Rejected';
      default: return 'Unknown';
    }
  }

  formatVehicleDate(date: any): string {
    if (!date) return '-';
    
    try {
      let dateObj: Date;
      
      if (date.seconds) {
        dateObj = new Date(date.seconds * 1000);
      } else if (date.toDate) {
        dateObj = date.toDate();
      } else {
        dateObj = new Date(date);
      }
      
      // Check if the date is valid
      if (isNaN(dateObj.getTime())) {
        return '-';
      }
      
      return dateObj.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch {
      return '-';
    }
  }

  // Payment related methods
  async openPaymentModal(record: ParkingRecord) {
    try {
      const success = await this.paymayaPaymentService.openSinglePaymentModal(
        record, 
        this.user,
        this.routeHelper.getRoutes().dashboard
      );
      
    } catch (error) {
      console.error('Error in openPaymentModal:', error);
      Swal.fire({
        title: 'Error',
        text: 'Failed to open payment modal. Please try again.',
        icon: 'error',
        confirmButtonColor: '#2196f3'
      });
    }
  }

  async openPaymentModalForAllUnpaid() {
    
    this.paymentError = '';
    
    if (this.unpaidRecords.length === 0) {
      Swal.fire({
        title: 'No Unpaid Sessions',
        text: 'You have no unpaid parking sessions.',
        icon: 'info',
        confirmButtonColor: '#2196f3'
      });
      return;
    }
    
    // Pre-calculate the total amount for all unpaid sessions
    try {
      const totalAmount = await this.calculateTotalUnpaidAmount();
      
      // Generate HTML for all unpaid sessions
      const sessionsHtml = this.unpaidRecords.map(record => `
        <div style="background: #f8f9fa; padding: 12px; border-radius: 6px; margin-bottom: 10px; border-left: 4px solid #e6e6e6;">
          <div style="display: flex; justify-content: between; align-items: start;">
            <div style="flex: 1;">
              <p style="margin: 0 0 8px 0; font-weight: 600; color: #333;"><strong>${record.plate_number}</strong></p>
              <div style="font-size: 13px; line-height: 1.4; color: #666;">
                <p style="margin: 0;"><strong>Parking location:</strong> ${record.zone_name}</p>
                <p style="margin: 0;"><strong>Assigned slot:</strong> ${record.slot_name}</p>
                <p style="margin: 0;"><strong>Time In:</strong> ${record.time_in}</p>
                <p style="margin: 0;"><strong>End:</strong> ${this.getEffectiveEndTime(record)}</p>
              </div>
            </div>
            <div style="text-align: right;">
              <p style="margin: 0; font-size: 16px; font-weight: bold;">₱${record.amount_due || record.amount_paid || 0}</p>
            </div>
          </div>
        </div>
      `).join('');
      
      // Show SweetAlert2 modal with all unpaid sessions
      const result = await Swal.fire({
        title: 'Pay All Unpaid Parking Fees',
        html: `
          <div style="text-align: left; margin: 20px 0;">
            <div style="background: #fff3cd; padding: 15px; border-radius: 8px; margin-bottom: 15px; border: 1px solid #e6e6e6;">
              <div style="display: flex; align-items: center; font-size: 14px; color: #856404;">
                <i class="fas fa-exclamation-triangle" style="margin-right: 8px; color: #f39c12;"></i>
                <div>
                  <p style="margin: 0; font-weight: 600;">Paying All Unpaid Parking Fees</p>
                  <p style="margin: 0;">You are about to pay for ${this.unpaidRecords.length} unpaid parking session${this.unpaidRecords.length > 1 ? 's' : ''}.</p>
                </div>
              </div>
            </div>
            
            <div style="margin-bottom: 15px;">
              <h4 style="margin: 0 0 10px 0; color: #333; font-size: 16px;">Unpaid Parking Fees (${this.unpaidRecords.length})</h4>
              <div style="max-height: 300px; overflow-y: auto; border: 1px solid #e6e6e6; border-radius: 6px; padding: 10px;">
                ${sessionsHtml}
              </div>
            </div>
            
            <div style="background: #f8f9fa; padding: 15px; border-radius: 8px; margin-bottom: 15px;">
              <p style="margin: 0 0 5px 0; color: black; font-size: 14px;">Total Amount to Pay</p>
              <p style="margin: 0; font-size: 2.5rem; font-weight: bold; color: black;">₱${totalAmount}</p>
            </div>
            
            <div class="text-center pt-8">
              <p class="text-blue-100 mt-2 mb-4">
                  <i class="fas fa-shield-alt mr-2"></i>Secure payment powered by
              </p>
              <img src="assets/img/Maya_logo.png" alt="Paymaya" style="width: 110px;" class="mt-2 mx-auto">
            </div>
          </div>
        `,
        showCancelButton: true,
        confirmButtonText: 'Pay Now',
        cancelButtonText: 'Cancel',
        confirmButtonColor: '#4829AA',
        cancelButtonColor: '#2e2e2e',
        width: '750px',
        allowEscapeKey: true,
        allowOutsideClick: true,
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          try {
            return await this.processPaymentForAllUnpaid(totalAmount);
          } catch (error) {
            Swal.showValidationMessage(
              `Payment failed: ${error.message || 'Unknown error'}`
            );
            return false;
          }
        }
      });
      
      if (result.isConfirmed && result.value) {
        // Payment processing will handle the redirect
      } else if (result.isDismissed) {
        this.closePaymentModal();
      }
      
    } catch (error) {
      console.error('Error in openPaymentModalForAllUnpaid:', error);
      Swal.fire({
        title: 'Error',
        text: 'Failed to open payment modal. Please try again.',
        icon: 'error',
        confirmButtonColor: '#2196f3'
      });
    }
  }

  closePaymentModal() {
    this.selectedUnpaidRecord = null;
    this.calculatedAmount = 0;
    this.paymentError = '';
    this.isProcessingPayment = false;
  }

  calculateParkingFee(record: ParkingRecord): Promise<number> {
    return this.paymayaPaymentService.calculateParkingFee(record);
  }

  async processPayment() {
    if (!this.selectedUnpaidRecord) {
      throw new Error('No unpaid record selected');
    }

    this.isProcessingPayment = true;
    this.paymentError = '';

    try {
      // Use the pre-calculated amount from modal
      const totalAmount = this.calculatedAmount;
      
      if (totalAmount <= 0) {
        throw new Error('Unable to calculate parking fee. Please try again.');
      }

      // Create invoice/payment record for tracking
      const invoiceData = {
        user_id: this.user.uid,
        plate_number: this.selectedUnpaidRecord.plate_number,
        zone_name: this.selectedUnpaidRecord.zone_name,
        slot_name: this.selectedUnpaidRecord.slot_name,
        parking_session_id: this.selectedUnpaidRecord.id,
        amount: totalAmount,
        currency: 'PHP',
        status: 'PENDING',
        payment_status: 'PENDING',
        created_at: new Date(),
        time_in: this.selectedUnpaidRecord.time_in,
        time_out: this.selectedUnpaidRecord.time_out,
        vehicle_type: this.selectedUnpaidRecord.vehicle_type,
        payment_method: 'maya'
      };

      // Generate Maya checkout payload
      const checkoutPayload = this.generateMayaCheckoutPayload(invoiceData);
      
      if (!checkoutPayload) {
        throw new Error('Unable to generate payment details. Please try again.');
      }

      // Create Maya checkout
      const checkoutResponse: any = await this.payMayaService.createCheckout(checkoutPayload).toPromise();
      
      // Handle both old and new PayMaya response structures
      const redirectUrl = checkoutResponse?.redirectUrl || checkoutResponse?.checkoutUrl;
      const checkoutId = checkoutResponse?.checkoutId;
      
      if (checkoutResponse && redirectUrl && checkoutId) {
        // Store payment record before redirect
        await this.storePaymentRecord({
          ...invoiceData,
          checkout_id: checkoutId,
          checkout_url: redirectUrl,
          maya_response: checkoutResponse,
          transaction_reference: this.generatePaymentReference(this.selectedUnpaidRecord.id)
        });

        // Store payment attempt in localStorage for recovery
        localStorage.setItem('lastPaymentAttempt', JSON.stringify({
          checkout_id: checkoutId,
          parking_session_id: this.selectedUnpaidRecord.id,
          plate_number: this.selectedUnpaidRecord.plate_number,
          zone_name: this.selectedUnpaidRecord.zone_name,
          amount: totalAmount,
          timestamp: new Date().toISOString(),
          user_id: this.user.uid,
          transaction_reference: this.generatePaymentReference(this.selectedUnpaidRecord.id)
        }));

        // Redirect to Maya checkout
        window.location.href = redirectUrl;
        return true; // Success for SweetAlert2
      } else {
        throw new Error('Invalid checkout response from Maya: ' + JSON.stringify(checkoutResponse));
      }

    } catch (error) {
      console.error('Payment processing error:', error);
      this.isProcessingPayment = false;
      throw error; // Re-throw for SweetAlert2 to handle
    }
  }

  async processPaymentForAllUnpaid(totalAmount: number) {
    if (this.unpaidRecords.length === 0) {
      throw new Error('No unpaid records to process');
    }

    this.isProcessingPayment = true;
    this.paymentError = '';

    try {
      if (totalAmount <= 0) {
        throw new Error('Unable to calculate total parking fee. Please try again.');
      }

      // Create invoice/payment record for all unpaid sessions
      const invoiceData = {
        user_id: this.user.uid,
        plate_numbers: this.unpaidRecords.map(record => record.plate_number || 'Unknown'),
        zone_names: this.unpaidRecords.map(record => record.zone_name || 'Unknown').join(', '),
        parking_session_ids: this.unpaidRecords.map(record => record.id || ''),
        amount: totalAmount,
        currency: 'PHP',
        status: 'PENDING',
        payment_status: 'PENDING',
        created_at: new Date(),
        payment_method: 'maya',
        session_count: this.unpaidRecords.length,
        sessions_detail: this.unpaidRecords.map(record => ({
          id: record.id || '',
          plate_number: record.plate_number || 'Unknown',
          zone_name: record.zone_name || 'Unknown',
          slot_name: record.slot_name || '-',
          time_in: record.time_in || '',
          time_out: record.time_out || null,
          auto_end_time: record.auto_end_time || null,
          amount: record.amount_due || record.amount_paid || 0
        }))
      };

      // Generate Maya checkout payload for all sessions
      const checkoutPayload = this.generateMayaCheckoutPayloadForAll(invoiceData);
      
      if (!checkoutPayload) {
        throw new Error('Unable to generate payment details. Please try again.');
      }

      // Create Maya checkout
      const checkoutResponse: any = await this.payMayaService.createCheckout(checkoutPayload).toPromise();
      
      // Handle both old and new PayMaya response structures
      const redirectUrl = checkoutResponse?.redirectUrl || checkoutResponse?.checkoutUrl;
      const checkoutId = checkoutResponse?.checkoutId;
      
      if (checkoutResponse && redirectUrl && checkoutId) {
        // Store payment record before redirect
        await this.storePaymentRecord({
          ...invoiceData,
          checkout_id: checkoutId,
          checkout_url: redirectUrl,
          maya_response: checkoutResponse,
          transaction_reference: this.generatePaymentReferenceForAll()
        });

        // Store payment attempt in localStorage for recovery
        localStorage.setItem('lastPaymentAttempt', JSON.stringify({
          checkout_id: checkoutId,
          parking_session_ids: this.unpaidRecords.map(record => record.id),
          plate_numbers: this.unpaidRecords.map(record => record.plate_number),
          zone_names: this.unpaidRecords.map(record => record.zone_name),
          amount: totalAmount,
          session_count: this.unpaidRecords.length,
          timestamp: new Date().toISOString(),
          user_id: this.user.uid,
          transaction_reference: this.generatePaymentReferenceForAll()
        }));

        // Redirect to Maya checkout
        window.location.href = redirectUrl;
        return true; // Success for SweetAlert2
      } else {
        throw new Error('Invalid checkout response from Maya: ' + JSON.stringify(checkoutResponse));
      }

    } catch (error) {
      console.error('Payment processing error for all unpaid:', error);
      this.isProcessingPayment = false;
      throw error; // Re-throw for SweetAlert2 to handle
    }
  }

  generateMayaCheckoutPayloadForAll(invoiceData: any): any {
    const userDisplayName = this.user?.displayName || this.user?.phoneNumber || 'User';
    const [firstName, ...lastNameParts] = userDisplayName.split(' ');
    const lastName = lastNameParts.join(' ') || 'User';

    return {
      totalAmount: {
        value: invoiceData.amount,
        currency: 'PHP'
      },
      buyer: {
        firstName: firstName || 'Parkbot',
        lastName: lastName || 'User',
        contact: {
          phone: this.user?.phoneNumber || '',
          email: this.user?.email || ''
        }
      },
      items: [
        {
          name: `Parking Fees - Multiple Sessions`,
          quantity: invoiceData.session_count,
          totalAmount: {
            value: invoiceData.amount,
            currency: 'PHP'
          },
          description: `Payment for ${invoiceData.session_count} unpaid parking sessions: ${invoiceData.plate_numbers.join(', ')}`
        }
      ],
      reference: this.generatePaymentReferenceForAll(),
      redirectUrl: {
        success: `${window.location.origin}${this.routeHelper.getRoutes().paymentSuccess}`,
        failure: `${window.location.origin}${this.routeHelper.getRoutes().paymentFailure}`, 
        cancel: `${window.location.origin}${this.routeHelper.getRoutes().paymentCancel}`
      },
      metadata: {
        user_id: this.user.uid,
        parking_session_ids: invoiceData.parking_session_ids,
        plate_numbers: invoiceData.plate_numbers,
        zone_names: invoiceData.zone_names,
        session_count: invoiceData.session_count,
        payment_type: 'bulk_unpaid_sessions'
      }
    };
  }

  private generatePaymentReferenceForAll(): string {
    // Create a short, unique reference under 36 characters for bulk payment
    const timestamp = Date.now().toString();
    // Take last 8 digits of timestamp for uniqueness
    const shortTimestamp = timestamp.slice(-8);
    
    // Generate random alphanumeric string
    const randomId = Math.random().toString(36).substring(2, 10).toUpperCase();
    
    // Format: BULK-XXXXXXXX-YYYYYYYY (max 27 chars)
    const reference = `BULK-${randomId}-${shortTimestamp}`;
    
    // Ensure we never exceed 36 characters
    return reference.length > 36 ? reference.substring(0, 36) : reference;
  }

  generateMayaCheckoutPayload(invoiceData: any): any {
    const userDisplayName = this.user?.displayName || this.user?.phoneNumber || 'User';
    const [firstName, ...lastNameParts] = userDisplayName.split(' ');
    const lastName = lastNameParts.join(' ') || 'User';

    return {
      totalAmount: {
        value: invoiceData.amount,
        currency: 'PHP'
      },
      buyer: {
        firstName: firstName || 'Parkbot',
        lastName: lastName || 'User',
        contact: {
          phone: this.user?.phoneNumber || '',
          email: this.user?.email || ''
        }
      },
      items: [
        {
          name: `Parking Fee - ${invoiceData.zone_name}`,
          quantity: 1,
          totalAmount: {
            value: invoiceData.amount,
            currency: 'PHP'
          },
          description: `Parking session for ${invoiceData.plate_number} at ${invoiceData.zone_name}, Slot ${invoiceData.slot_name}`
        }
      ],
      reference: this.generatePaymentReference(invoiceData.parking_session_id),
      redirectUrl: {
        success: `${window.location.origin}${this.routeHelper.getRoutes().paymentSuccess}`,
        failure: `${window.location.origin}${this.routeHelper.getRoutes().paymentFailure}`, 
        cancel: `${window.location.origin}${this.routeHelper.getRoutes().paymentCancel}`
      },
      metadata: {
        user_id: this.user.uid,
        parking_session_id: invoiceData.parking_session_id,
        plate_number: invoiceData.plate_number,
        zone_name: invoiceData.zone_name
      }
    };
  }

  async storePaymentRecord(paymentData: any) {
    try {
      // Clean up the payment data to avoid undefined values and ensure Firestore compatibility
      const cleanedData = this.cleanPaymentDataForFirestore(paymentData);
      
      await firebase.firestore().collection('online_payments').add({
        ...cleanedData,
        payment_method: 'maya',
        created_at: firebase.firestore.FieldValue.serverTimestamp(),
        updated_at: firebase.firestore.FieldValue.serverTimestamp()
      });
    } catch (error) {
      console.error('Error storing payment record:', error);
      throw error;
    }
  }

  private cleanPaymentDataForFirestore(data: any): any {
    const cleaned: any = {};
    
    // Copy all defined values, converting complex objects to simple types
    Object.keys(data).forEach(key => {
      const value = data[key];
      
      if (value !== undefined && value !== null) {
        if (Array.isArray(value)) {
          // Handle arrays - filter out undefined values
          cleaned[key] = value.filter(item => item !== undefined && item !== null);
        } else if (typeof value === 'object' && value.constructor === Object) {
          // Handle plain objects - recursively clean
          const cleanedObj = this.cleanPaymentDataForFirestore(value);
          if (Object.keys(cleanedObj).length > 0) {
            cleaned[key] = cleanedObj;
          }
        } else if (typeof value === 'object' && value._seconds) {
          // Handle Firebase timestamps - keep as is
          cleaned[key] = value;
        } else if (value instanceof Date) {
          // Convert Date objects to Firestore timestamp
          cleaned[key] = firebase.firestore.Timestamp.fromDate(value);
        } else {
          // Handle primitive types
          cleaned[key] = value;
        }
      }
    });
    
    return cleaned;
  }

  private generatePaymentReference(sessionId: string): string {
    // Create a short, unique reference under 36 characters
    const timestamp = Date.now().toString();
    // Take last 8 digits of timestamp for uniqueness
    const shortTimestamp = timestamp.slice(-8);
    
    // Take first 8 characters of session ID if it exists, otherwise use random
    let shortSessionId = '';
    if (sessionId && sessionId.length > 0) {
      shortSessionId = sessionId.replace(/[^a-zA-Z0-9]/g, '').slice(0, 8).toUpperCase();
    }
    
    if (shortSessionId.length === 0) {
      // Fallback: generate random alphanumeric string
      shortSessionId = Math.random().toString(36).substring(2, 10).toUpperCase();
    }
    
    // Format: PARK-XXXXXXXX-YYYYYYYY (max 25 chars)
    const reference = `PARK-${shortSessionId}-${shortTimestamp}`;
    
    // Ensure we never exceed 36 characters
    return reference.length > 36 ? reference.substring(0, 36) : reference;
  }

  private handlePaymentStatusReturn(paymentStatus: string, transactionId?: string) {
    const statusMessages = {
      'success': 'Payment completed successfully! Your parking session has been paid.',
      'failed': 'Payment failed. Please try again or contact support.',
      'cancelled': 'Payment was cancelled. You can try again when ready.',
      'expired': 'Payment session expired. Please start a new payment.'
    };

    const statusIcons = {
      'success': 'success',
      'failed': 'error',
      'cancelled': 'warning',
      'expired': 'info'
    };

    const message = statusMessages[paymentStatus] || 'Payment status unknown.';
    const icon = statusIcons[paymentStatus] || 'info';

    Swal.fire({
      title: 'Payment Status',
      text: message,
      icon: icon as any,
      confirmButtonColor: '#2196f3',
      confirmButtonText: 'OK'
    }).then(() => {
      // Refresh parking records after showing the status
      this.loadParkingRecords().then(() => {
        this.calculateStats();
      });
      
      // Clear query params
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: {},
        replaceUrl: true
      });
    });
  }

  viewVehicleDetails(vehicle: UserVehicle) {
    const statusColor = this.getVehicleStatusColor(vehicle.verification_status);
    const statusIcon = this.getVehicleStatusIcon(vehicle.verification_status);
    
    // Get documents from uploaded_documents object
    const documents = this.getDocumentsFromVehicleObject(vehicle);
    
    const documentsHtml = documents.length > 0 ? `
      <div class="mt-4 pt-4 border-t border-gray-200">
        <h4 class="text-sm font-semibold text-gray-800 mb-3 flex items-center">
          <i class="fas fa-folder-open mr-2 text-blue-600"></i>Documents (${documents.length})
        </h4>
        <div class="grid grid-cols-1 gap-3">
          ${documents.map(doc => `
            <div class="mb-4 bg-gray-50 rounded-lg p-4 hover:bg-gray-100 cursor-pointer border border-gray-200" onclick="window.open('${doc.url}', '_blank')">
              <div class="flex items-start space-x-3">
                <div class="flex-shrink-0 mr-2">
                  <i class="fas ${doc.isPdf ? 'fa-file-pdf text-red-500' : doc.isImage ? 'fa-image text-blue-500' : 'fa-file text-gray-500'} text-lg"></i>
                </div>
                <div class="flex-1 min-w-0">
                  <div class="flex items-center justify-between">
                    <p class="text-sm font-medium text-gray-800 truncate">${doc.name}</p>
                    <i class="fas fa-external-link-alt text-gray-400 text-xs ml-2"></i>
                  </div>
                  <p class="text-xs text-gray-600 mt-1">${doc.fileName || 'Document'}</p>
                  <div class="flex items-center space-x-2 mt-2">
                    <span class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${doc.isPdf ? 'bg-red-100 text-red-800' : doc.isImage ? 'bg-blue-100 text-blue-800' : 'bg-gray-100 text-gray-800'}">
                      ${doc.fileExtension ? doc.fileExtension.toUpperCase() : 'FILE'}
                    </span>
                    ${doc.uploadedAt ? `
                      <span class="text-xs text-gray-500">
                        <i class="fas fa-clock mr-1"></i>${doc.uploadedAt}
                      </span>
                    ` : ''}
                  </div>
                </div>
              </div>
            </div>
          `).join('')}
        </div>
      </div>
    ` : '';

    // Helper function to format Firestore timestamps
    const formatTimestamp = (timestamp: any): string => {
      if (!timestamp) return '-';
      
      if (timestamp._seconds) {
        // Firestore timestamp object
        const date = new Date(timestamp._seconds * 1000);
        return date.toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        });
      } else if (timestamp instanceof Date) {
        // Date object
        return timestamp.toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        });
      } else if (typeof timestamp === 'string') {
        // String date
        const date = new Date(timestamp);
        return date.toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        });
      }
      return '-';
    };

    Swal.fire({
      title: `<div class="flex items-center justify-center">
                <i class="fas fa-car text-blue-600 mr-3"></i>
                <span class="text-4xl font-bold">${vehicle.plate_number || '-'}</span>
              </div>`,
      html: `
        <div class="text-left space-y-4">
          <!-- Status Badge -->
          <div class="flex justify-center mb-4">
            <span class="px-4 py-2 rounded-full text-sm font-semibold ${statusColor}">
              <i class="${statusIcon} mr-2"></i>${this.getVehicleStatusText(vehicle.verification_status)}
            </span>
          </div>

          <!-- Vehicle Information -->
          <div class="mb-4 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg p-4 border border-blue-100">
            <h4 class="text-sm font-semibold text-gray-800 mb-3 flex items-center">
              <i class="fas fa-car mr-2 text-blue-600"></i>Vehicle Details
            </h4>
            <div class="grid grid-cols-2 gap-x-6 gap-y-3 text-sm">
              <div>
                <span class="font-medium text-gray-600">Type:</span>
                <span class="ml-2 text-gray-800 font-bold text-lg">${vehicle.vehicle_type || '-'}</span>
              </div>
              <div>
                <span class="font-medium text-gray-600">Model:</span>
                <span class="ml-2 text-gray-800 font-bold text-lg">${vehicle.vehicle_model || '-'}</span>
              </div>
              <div>
                <span class="font-medium text-gray-600">Color:</span>
                <span class="ml-2 text-gray-800 font-bold text-lg">${vehicle.vehicle_color || '-'}</span>
              </div>
              <div>
                <span class="font-medium text-gray-600">Category:</span>
                <span class="ml-2 text-gray-800 font-bold text-lg">${vehicle.vehicle_type_custom_name || '-'}</span>
              </div>
              ${vehicle.code ? `
                <div>
                  <span class="font-medium text-gray-600">Code:</span>
                  <span class="ml-2 text-gray-800 font-bold text-lg text-xs">${vehicle.code}</span>
                </div>
              ` : ''}
              ${vehicle.vin_number ? `
                <div>
                  <span class="font-medium text-gray-600">VIN:</span>
                  <span class="ml-2 text-gray-800 font-bold text-lg text-xs">${vehicle.vin_number}</span>
                </div>
              ` : ''}
              ${vehicle.latest_log_id ? `
                <div class="col-span-2">
                  <span class="font-medium text-gray-600">Latest Activity:</span>
                  <span class="ml-2 text-gray-800 font-mono text-xs">${vehicle.latest_log_id}</span>
                </div>
              ` : ''}
              ${vehicle.id ? `
                <div class="col-span-2">
                  <span class="font-medium text-gray-600">Vehicle ID:</span>
                  <span class="ml-2 text-gray-800 font-mono text-xs">${vehicle.id}</span>
                </div>
              ` : ''}
            </div>
          </div>

          <!-- Owner Information -->
          <div class="mb-4 bg-gray-50 rounded-lg p-4 border border-gray-200">
            <h4 class="text-sm font-semibold text-gray-800 mb-3 flex items-center">
              <i class="fas fa-user mr-2 text-green-600"></i>Owner Details
            </h4>
            <div class="grid grid-cols-1 gap-2 text-sm">
              <div>
                <span class="font-medium text-gray-600">Name:</span>
                <span class="ml-2 text-gray-800">${vehicle.owner_full_name || '-'}</span>
              </div>
              <div>
                <span class="font-medium text-gray-600">Contact:</span>
                <span class="ml-2 text-gray-800">${vehicle.owner_contact_number || '-'}</span>
              </div>
              <div>
                <span class="font-medium text-gray-600">Email:</span>
                <span class="ml-2 text-gray-800 text-xs">${vehicle.owner_email || '-'}</span>
              </div>
              <div>
                <span class="font-medium text-gray-600">License:</span>
                <span class="ml-2 text-gray-800 text-xs">${vehicle.driver_license_number || '-'}</span>
              </div>
              ${vehicle.user_id ? `
                <div>
                  <span class="font-medium text-gray-600">User ID:</span>
                  <span class="ml-2 text-gray-800 font-mono text-xs">${vehicle.user_id}</span>
                </div>
              ` : ''}
              ${vehicle.owner_id ? `
                <div>
                  <span class="font-medium text-gray-600">Owner ID:</span>
                  <span class="ml-2 text-gray-800 font-mono text-xs">${vehicle.owner_id}</span>
                </div>
              ` : ''}
            </div>
          </div>

          <!-- Registration Info -->
          <div class="mb-4 bg-yellow-50 rounded-lg p-4 border border-yellow-200">
            <h4 class="text-sm font-semibold text-gray-800 mb-3 flex items-center">
              <i class="fas fa-calendar-alt mr-2 text-yellow-600"></i>Timeline
            </h4>
            <div class="grid grid-cols-1 gap-2 text-sm">
              ${vehicle.date_created ? `
                <div>
                  <span class="font-medium text-gray-600">Created:</span>
                  <span class="ml-2 text-gray-800">${formatTimestamp(vehicle.date_created)}</span>
                </div>
              ` : ''}
              <div>
                <span class="font-medium text-gray-600">Registered:</span>
                <span class="ml-2 text-gray-800">${formatTimestamp(vehicle.date_registered)}</span>
              </div>
              ${vehicle.verified_date ? `
                <div>
                  <span class="font-medium text-gray-600">Verified:</span>
                  <span class="ml-2 text-gray-800">${formatTimestamp(vehicle.verified_date)}</span>
                </div>
              ` : ''}
              ${vehicle.verified_by ? `
                <div>
                  <span class="font-medium text-gray-600">Verified By:</span>
                  <span class="ml-2 text-gray-800">${vehicle.verified_by}</span>
                </div>
              ` : ''}
              ${vehicle.updated_at || vehicle.updatedAt ? `
                <div>
                  <span class="font-medium text-gray-600">Last Updated:</span>
                  <span class="ml-2 text-gray-800">${formatTimestamp(vehicle.updated_at || vehicle.updatedAt)}</span>
                </div>
              ` : ''}
              ${vehicle.rejection_reason ? `
                <div class="bg-red-100 rounded p-2 mt-2">
                  <span class="font-medium text-red-600">Rejection Reason:</span>
                  <p class="text-red-800 text-xs mt-1">${vehicle.rejection_reason}</p>
                </div>
              ` : ''}
              ${vehicle.previous_owner_id ? `
                <div class="bg-blue-100 rounded p-2 mt-2">
                  <span class="font-medium text-blue-600">Previous Owner ID:</span>
                  <p class="text-blue-800 text-xs mt-1 font-mono">${vehicle.previous_owner_id}</p>
                </div>
              ` : ''}
              ${vehicle.deleted !== undefined ? `
                <div class="bg-orange-100 rounded p-2 mt-2">
                  <span class="font-medium text-orange-600">Status:</span>
                  <p class="text-orange-800 text-xs mt-1">${vehicle.deleted ? 'Deleted' : 'Active'}</p>
                </div>
              ` : ''}
            </div>
          </div>

          ${documentsHtml}
        </div>
      `,
      width: '680px',
      showCloseButton: true,
      showConfirmButton: false,
      customClass: {
        popup: 'vehicle-details-modal',
        title: 'text-center'
      },
      didOpen: () => {
        // Add custom styles
        const style = document.createElement('style');
        style.textContent = `
          .vehicle-details-modal {
            border-radius: 16px !important;
            padding: 0 !important;
          }
          .vehicle-details-modal .swal2-header {
            padding: 24px 24px 0 24px !important;
          }
          .vehicle-details-modal .swal2-content {
            padding: 20px 24px 24px 24px !important;
          }
        `;
        document.head.appendChild(style);
      }
    });
  }

  private getVehicleStatusColor(status: string | undefined): string {
    switch (status) {
      case 'verified': return 'bg-green-100 text-green-800 border border-green-200';
      case 'pending': return 'bg-yellow-100 text-yellow-800 border border-yellow-200';
      case 'rejected': return 'bg-red-100 text-red-800 border border-red-200';
      default: return 'bg-gray-100 text-gray-800 border border-gray-200';
    }
  }

  private getVehicleStatusIcon(status: string | undefined): string {
    switch (status) {
      case 'verified': return 'fas fa-check-circle';
      case 'pending': return 'fas fa-clock';
      case 'rejected': return 'fas fa-times-circle';
      default: return 'fas fa-question-circle';
    }
  }


  private getFileExtensionFromUrl(url: string): string {
    try {
      // Extract filename from URL
      const urlParts = url.split('/');
      const filename = urlParts[urlParts.length - 1];
      
      // Remove query parameters if any
      const cleanFilename = filename.split('?')[0];
      
      // Get file extension
      const extension = cleanFilename.split('.').pop()?.toLowerCase() || '';
      return extension;
    } catch (error) {
      return '';
    }
  }

  private getFileNameFromUrl(url: string): string {
    try {
      // Extract filename from URL
      const urlParts = url.split('/');
      const filename = urlParts[urlParts.length - 1];
      
      // Remove query parameters if any
      const cleanFilename = filename.split('?')[0];
      
      return cleanFilename || '';
    } catch (error) {
      return '';
    }
  }
  

  private getDocumentsFromVehicleObject(vehicle: UserVehicle): any[] {
    const documents: any[] = [];
    
    if (vehicle.uploaded_documents) {
      // Handle CR document
      if (vehicle.uploaded_documents.cr_document && typeof vehicle.uploaded_documents.cr_document === 'string') {
        const fileExtension = this.getFileExtensionFromUrl(vehicle.uploaded_documents.cr_document);
        documents.push({
          name: 'Certificate of Registration',
          url: vehicle.uploaded_documents.cr_document,
          isPdf: fileExtension === 'pdf',
          isImage: ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(fileExtension),
          type: 'cr_documents',
          fileName: this.getFileNameFromUrl(vehicle.uploaded_documents.cr_document) || 'CR Document',
          fileExtension: fileExtension,
          uploadedAt: 'From uploaded documents'
        });
      }

      // Handle driver's license documents (array)
      if (vehicle.uploaded_documents.drivers_license && Array.isArray(vehicle.uploaded_documents.drivers_license)) {
        vehicle.uploaded_documents.drivers_license.forEach((license, index) => {
          if (typeof license === 'string') {
            const fileExtension = this.getFileExtensionFromUrl(license);
            documents.push({
              name: `Driver's License ${index + 1}`,
              url: license,
              isPdf: fileExtension === 'pdf',
              isImage: ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(fileExtension),
              type: 'drivers_licenses',
              fileName: this.getFileNameFromUrl(license) || `License ${index + 1}`,
              fileExtension: fileExtension,
              uploadedAt: 'From uploaded documents'
            });
          }
        });
      }

      // Handle OR document if it exists
      if (vehicle.uploaded_documents.or_document && typeof vehicle.uploaded_documents.or_document === 'string') {
        const fileExtension = this.getFileExtensionFromUrl(vehicle.uploaded_documents.or_document);
        documents.push({
          name: 'Official Receipt',
          url: vehicle.uploaded_documents.or_document,
          isPdf: fileExtension === 'pdf',
          isImage: ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(fileExtension),
          type: 'or_documents',
          fileName: this.getFileNameFromUrl(vehicle.uploaded_documents.or_document) || 'OR Document',
          fileExtension: fileExtension,
          uploadedAt: 'From uploaded documents'
        });
      }

      // Handle government ID if it exists
      if (vehicle.uploaded_documents.government_id && typeof vehicle.uploaded_documents.government_id === 'string') {
        const fileExtension = this.getFileExtensionFromUrl(vehicle.uploaded_documents.government_id);
        documents.push({
          name: 'Government ID',
          url: vehicle.uploaded_documents.government_id,
          isPdf: fileExtension === 'pdf',
          isImage: ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(fileExtension),
          type: 'government_ids',
          fileName: this.getFileNameFromUrl(vehicle.uploaded_documents.government_id) || 'Government ID',
          fileExtension: fileExtension,
          uploadedAt: 'From uploaded documents'
        });
      }

      // Handle insurance document if it exists
      if (vehicle.uploaded_documents.insurance_document && typeof vehicle.uploaded_documents.insurance_document === 'string') {
        const fileExtension = this.getFileExtensionFromUrl(vehicle.uploaded_documents.insurance_document);
        documents.push({
          name: 'Insurance Document',
          url: vehicle.uploaded_documents.insurance_document,
          isPdf: fileExtension === 'pdf',
          isImage: ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(fileExtension),
          type: 'insurance_documents',
          fileName: this.getFileNameFromUrl(vehicle.uploaded_documents.insurance_document) || 'Insurance Document',
          fileExtension: fileExtension,
          uploadedAt: 'From uploaded documents'
        });
      }
    }

    return documents;
  }

  // ==================== NOTIFICATION METHODS ====================

  /**
   * Request notification permission from browser
   * Automatically requests on first visit, similar to location/camera access
   */
  async requestNotificationPermission(): Promise<void> {
    if (!this.fcmNotificationService.isSupported()) {
      console.warn('[Notifications] Push notifications not supported in this browser');
      this.notificationPermission = 'denied';
      return;
    }

    try {
      // Get current permission status
      this.notificationPermission = Notification.permission;

      // Check if we've already prompted the user this session
      const hasPrompted = sessionStorage.getItem('parkbot_notification_prompted');

      // If permission hasn't been requested yet, automatically request it
      if (this.notificationPermission === 'default' && !hasPrompted) {
        console.log('[Notifications] Auto-requesting permission...');

        // Mark that we've prompted in this session
        sessionStorage.setItem('parkbot_notification_prompted', 'true');

        // Show a friendly SweetAlert before requesting permission
        const shouldRequest = await Swal.fire({
          title: 'Stay Updated!',
          html: `
            <div class="text-left">
              <p class="mb-3">Enable notifications to receive instant alerts about:</p>
              <ul class="list-disc list-inside space-y-2 text-sm text-gray-700">
                <li><i class="fas fa-parking text-blue-500 mr-2"></i>New parking sessions starting</li>
                <li><i class="fas fa-clock text-orange-500 mr-2"></i>Session expiration warnings</li>
                <li><i class="fas fa-check-circle text-green-500 mr-2"></i>Completed parking sessions</li>
                <li><i class="fas fa-dollar-sign text-yellow-500 mr-2"></i>Payment reminders</li>
              </ul>
              <p class="mt-3 text-sm text-gray-500">
                <i class="fas fa-info-circle mr-1"></i>Works even when app is in background or closed
              </p>
            </div>
          `,
          icon: 'info',
          showCancelButton: true,
          confirmButtonText: '<i class="fas fa-bell mr-2"></i>Enable Notifications',
          cancelButtonText: 'Maybe Later',
          confirmButtonColor: '#2196f3',
          cancelButtonColor: '#6b7280',
          allowOutsideClick: true,
          allowEscapeKey: true
        });

        if (shouldRequest.isConfirmed) {
          // Request permission and get FCM token
          const fcmToken = await this.fcmNotificationService.requestPermissionAndGetToken();

          if (fcmToken) {
            this.notificationPermission = 'granted';
            console.log('[Notifications] Permission granted and FCM token obtained');

            // Save FCM token to Firestore
            if (this.user?.phoneNumber) {
              await this.fcmNotificationService.saveFcmTokenForPublicUser(
                this.user.phoneNumber,
                fcmToken
              );
            } else if (this.user?.uid) {
              await this.fcmNotificationService.saveFcmTokenToFirestore(
                this.user.uid,
                fcmToken
              );
            }

            // Setup foreground message handler
            this.fcmNotificationService.onForegroundMessage((payload) => {
              console.log('[Notifications] Foreground message received:', payload);
              this.showBrowserNotificationFromPayload(payload);
            });

            // Show success message
            await Swal.fire({
              title: 'Notifications Enabled!',
              text: 'You\'ll now receive alerts about your parking sessions, even when the app is closed.',
              icon: 'success',
              timer: 3000,
              showConfirmButton: false
            });

            // Show a test notification
            this.showTestNotification();
          } else {
            this.notificationPermission = Notification.permission;

            if (this.notificationPermission === 'denied') {
              await Swal.fire({
                title: 'Notifications Blocked',
                html: 'You can enable notifications later from the Notifications tab or your browser settings.',
                icon: 'info',
                timer: 3000,
                showConfirmButton: false
              });
            }
          }
        } else {
          console.log('[Notifications] User chose to enable notifications later');

          // Show a subtle reminder
          await Swal.fire({
            text: 'You can enable notifications anytime from the bell icon in the header.',
            icon: 'info',
            timer: 2500,
            showConfirmButton: false,
            position: 'top-end',
            toast: true
          });
        }
      } else if (this.notificationPermission === 'granted') {
        console.log('[Notifications] Permission already granted, setting up FCM...');

        // Get FCM token if we don't have it yet
        const fcmToken = await this.fcmNotificationService.requestPermissionAndGetToken();
        if (fcmToken && this.user) {
          if (this.user.phoneNumber) {
            await this.fcmNotificationService.saveFcmTokenForPublicUser(
              this.user.phoneNumber,
              fcmToken
            );
          } else if (this.user.uid) {
            await this.fcmNotificationService.saveFcmTokenToFirestore(
              this.user.uid,
              fcmToken
            );
          }

          // Setup foreground message handler
          this.fcmNotificationService.onForegroundMessage((payload) => {
            console.log('[Notifications] Foreground message received:', payload);
            this.showBrowserNotificationFromPayload(payload);
          });
        }
      } else if (this.notificationPermission === 'denied') {
        console.log('[Notifications] Permission previously denied');
      } else if (hasPrompted) {
        console.log('[Notifications] Already prompted in this session');
      }

      // Update component state
      this.cdr.detectChanges();
    } catch (error) {
      console.error('[Notifications] Error requesting permission:', error);
      this.notificationPermission = 'denied';
    }
  }

  /**
   * Show a test notification to confirm notifications are working
   */
  private showTestNotification(): void {
    try {
      if (this.notificationPermission === 'granted') {
        const testNotification = new Notification('Parkbot Notifications Enabled', {
          body: 'You\'ll receive updates about your parking sessions here.',
          icon: '/assets/icons/icon-192.png',
          badge: '/assets/icons/icon-72.png',
          tag: 'test-notification',
          requireInteraction: false,
          silent: false
        });

        // Auto-close after 4 seconds
        setTimeout(() => {
          testNotification.close();
        }, 4000);

        testNotification.onclick = () => {
          window.focus();
          testNotification.close();
        };

        console.log('[Notifications] Test notification shown');
      }
    } catch (error) {
      console.error('[Notifications] Error showing test notification:', error);
    }
  }

  /**
   * Set up real-time listener for driver notifications
   */
  setupNotificationsListener(): void {
    // Clean up existing listener if any
    if (this.notificationsUnsubscriber) {
      this.notificationsUnsubscriber();
    }

    console.log('[Notifications] Setting up listener...');
    console.log('[Notifications] Total user vehicles:', this.userVehicles.length);

    // Get user's verified vehicles to filter notifications
    const verifiedVehicles = this.userVehicles.filter(v => v.verification_status === 'verified');
    console.log('[Notifications] Verified vehicles:', verifiedVehicles.length);

    if (verifiedVehicles.length === 0) {
      console.log('[Notifications] No verified vehicles found, skipping notification listener setup');
      console.log('[Notifications] All vehicles status:', this.userVehicles.map(v => ({
        plate: v.plate_number,
        status: v.verification_status
      })));
      this.driverNotifications = [];
      this.unreadNotificationsCount = 0;
      return;
    }

    const plateNumbers = verifiedVehicles.map(v => v.plate_number).filter(Boolean);

    if (plateNumbers.length === 0) {
      console.log('[Notifications] No plate numbers found for verified vehicles');
      return;
    }

    this.isLoadingNotifications = true;

    console.log('[Notifications] Setting up listener for plate numbers:', plateNumbers);

    // Set up Firestore real-time listener
    // Note: Firestore 'in' query supports up to 10 values
    // If user has more than 10 vehicles, we need to batch the queries
    const batchSize = 10;
    const batches = [];

    for (let i = 0; i < plateNumbers.length; i += batchSize) {
      batches.push(plateNumbers.slice(i, i + batchSize));
    }

    // Set up listener for each batch
    const unsubscribers: (() => void)[] = [];
    const allNotifications: DriverNotification[] = [];

    batches.forEach((batch, batchIndex) => {
      const unsubscriber = firebase.firestore()
        .collection('driver_notifications')
        .where('plate_number', 'in', batch)
        .orderBy('created_at', 'desc')
        .limit(50)
        .onSnapshot((snapshot) => {
          console.log(`[Notifications] Batch ${batchIndex + 1} snapshot received:`, snapshot.size, 'notifications');

          // Clear notifications for this batch
          const batchStartIndex = batchIndex * 50;
          allNotifications.splice(batchStartIndex, 50);

          // Add new notifications from this batch
          snapshot.forEach(doc => {
            const data = doc.data();
            allNotifications.push({
              id: doc.id,
              plate_number: data.plate_number,
              type: data.type,
              title: data.title,
              message: data.message,
              session_id: data.session_id,
              slot_code: data.slot_code,
              slot_id: data.slot_id,
              slot_name: data.slot_name,
              zone_id: data.zone_id,
              zone_name: data.zone_name,
              is_read: data.is_read,
              created_at: data.created_at,
              read_at: data.read_at,
              metadata: data.metadata
            });
          });

          // Check for new unread notifications and show browser notification
          snapshot.docChanges().forEach((change) => {
            if (change.type === 'added') {
              const notification = change.doc.data();

              // Only show browser notification if it's unread and just created
              if (!notification.is_read) {
                this.showBrowserNotification(notification);
              }
            }
          });

          // Update component state
          this.driverNotifications = allNotifications.sort((a, b) => {
            const timeA = a.created_at?.seconds ? a.created_at.seconds : 0;
            const timeB = b.created_at?.seconds ? b.created_at.seconds : 0;
            return timeB - timeA;
          });

          this.unreadNotificationsCount = this.driverNotifications.filter(n => !n.is_read).length;
          this.isLoadingNotifications = false;
          this.cdr.detectChanges();

          console.log(`[Notifications] Updated: ${this.driverNotifications.length} total, ${this.unreadNotificationsCount} unread`);
        }, (error) => {
          console.error('[Notifications] Error in listener:', error);
          this.isLoadingNotifications = false;
          this.cdr.detectChanges();
        });

      unsubscribers.push(unsubscriber);
    });

    // Store all unsubscribers
    this.notificationsUnsubscriber = () => {
      unsubscribers.forEach(unsub => unsub());
    };
  }

  /**
   * Show browser notification for new parking events
   */
  showBrowserNotification(notification: any): void {
    if ('Notification' in window && this.notificationPermission === 'granted') {
      try {
        const browserNotification = new Notification(notification.title, {
          body: notification.message,
          icon: '/assets/icons/icon-192.png',
          badge: '/assets/icons/icon-72.png',
          tag: notification.session_id || notification.id,
          requireInteraction: false,
          silent: false,
          data: {
            notification_id: notification.id,
            session_id: notification.session_id,
            type: notification.type,
            plate_number: notification.plate_number
          }
        });

        // Handle notification click
        browserNotification.onclick = (event) => {
          event.preventDefault();
          window.focus();

          // Mark notification as read
          this.markNotificationAsRead(notification.id);

          // Navigate to parking tab to show the session
          this.setActiveTab('parking');

          // Close the notification
          browserNotification.close();
        };

        console.log('[Notifications] Browser notification shown:', notification.title);
      } catch (error) {
        console.error('[Notifications] Error showing browser notification:', error);
      }
    }
  }

  /**
   * Show browser notification from FCM payload (foreground messages)
   */
  showBrowserNotificationFromPayload(payload: any): void {
    if ('Notification' in window && this.notificationPermission === 'granted') {
      try {
        const title = payload.notification?.title || payload.data?.title || 'Parkbot Notification';
        const body = payload.notification?.body || payload.data?.body || '';

        const browserNotification = new Notification(title, {
          body: body,
          icon: payload.notification?.icon || '/assets/icons/icon-192.png',
          badge: '/assets/icons/icon-72.png',
          tag: payload.data?.session_id || payload.data?.notification_id || 'parkbot-notification',
          requireInteraction: false,
          silent: false,
          data: payload.data
        });

        // Handle notification click
        browserNotification.onclick = (event) => {
          event.preventDefault();
          window.focus();

          // Mark notification as read if we have notification_id
          if (payload.data?.notification_id) {
            this.markNotificationAsRead(payload.data.notification_id);
          }

          // Navigate to dashboard
          this.setActiveTab('notifications');

          // Close the notification
          browserNotification.close();
        };

        console.log('[Notifications] FCM browser notification shown:', title);
      } catch (error) {
        console.error('[Notifications] Error showing FCM browser notification:', error);
      }
    }
  }

  /**
   * Mark a single notification as read
   */
  async markNotificationAsRead(notificationId: string): Promise<void> {
    try {
      await firebase.firestore()
        .collection('driver_notifications')
        .doc(notificationId)
        .update({
          is_read: true,
          read_at: firebase.firestore.FieldValue.serverTimestamp()
        });

      console.log('[Notifications] Marked as read:', notificationId);
    } catch (error) {
      console.error('[Notifications] Error marking notification as read:', error);
    }
  }

  /**
   * Mark all notifications as read for current user
   */
  async markAllNotificationsAsRead(): Promise<void> {
    try {
      const verifiedVehicles = this.userVehicles.filter(v => v.verification_status === 'verified');
      const plateNumbers = verifiedVehicles.map(v => v.plate_number).filter(Boolean);

      if (plateNumbers.length === 0) {
        return;
      }

      // Use HTTP API endpoint to mark all as read
      const response: any = await this.http.post(`${environment.apiBaseUrl}/markNotificationsAsRead`, {
        plateNumbers: plateNumbers,
        markAllAsRead: true
      }).toPromise();

      if (response.success) {
        console.log('[Notifications] All notifications marked as read:', response.updated);

        // Show success message
        Swal.fire({
          title: 'Success',
          text: `${response.updated} notification${response.updated !== 1 ? 's' : ''} marked as read`,
          icon: 'success',
          timer: 2000,
          showConfirmButton: false
        });
      }
    } catch (error) {
      console.error('[Notifications] Error marking all as read:', error);
      Swal.fire({
        title: 'Error',
        text: 'Failed to mark notifications as read',
        icon: 'error',
        confirmButtonColor: '#2196f3'
      });
    }
  }

  /**
   * Get notification badge for specific types
   */
  getNotificationBadgeClass(type: string): string {
    switch (type) {
      case 'new_session':
        return 'bg-blue-100 text-blue-800';
      case 'session_expired':
        return 'bg-orange-100 text-orange-800';
      case 'session_completed':
        return 'bg-green-100 text-green-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  }

  /**
   * Get notification icon for specific types
   */
  getNotificationIcon(type: string): string {
    switch (type) {
      case 'new_session':
        return 'fas fa-parking';
      case 'session_expired':
        return 'fas fa-clock';
      case 'session_completed':
        return 'fas fa-check-circle';
      default:
        return 'fas fa-bell';
    }
  }

  /**
   * Format notification timestamp
   */
  formatNotificationTime(timestamp: any): string {
    if (!timestamp) return '';

    try {
      let date: Date;
      if (timestamp.seconds) {
        date = new Date(timestamp.seconds * 1000);
      } else if (timestamp.toDate) {
        date = timestamp.toDate();
      } else {
        date = new Date(timestamp);
      }

      const now = new Date();
      const diffMs = now.getTime() - date.getTime();
      const diffMins = Math.floor(diffMs / 60000);
      const diffHours = Math.floor(diffMs / 3600000);
      const diffDays = Math.floor(diffMs / 86400000);

      if (diffMins < 1) {
        return 'Just now';
      } else if (diffMins < 60) {
        return `${diffMins} minute${diffMins > 1 ? 's' : ''} ago`;
      } else if (diffHours < 24) {
        return `${diffHours} hour${diffHours > 1 ? 's' : ''} ago`;
      } else if (diffDays < 7) {
        return `${diffDays} day${diffDays > 1 ? 's' : ''} ago`;
      } else {
        return date.toLocaleDateString('en-US', {
          month: 'short',
          day: 'numeric',
          year: date.getFullYear() !== now.getFullYear() ? 'numeric' : undefined
        });
      }
    } catch (error) {
      console.error('[Notifications] Error formatting time:', error);
      return '';
    }
  }

  /**
   * Handle notification click - navigate to related session
   */
  handleNotificationClick(notification: DriverNotification): void {
    // Mark as read
    if (!notification.is_read) {
      this.markNotificationAsRead(notification.id);
    }

    // Stay on notifications tab instead of navigating away
    // this.setActiveTab('parking');

    // Optionally, scroll to the specific session or highlight it
    // This would require additional implementation in the template
  }

  /**
   * Delete a notification (optional feature)
   */
  async deleteNotification(notificationId: string): Promise<void> {
    try {
      await firebase.firestore()
        .collection('driver_notifications')
        .doc(notificationId)
        .delete();

      console.log('[Notifications] Deleted:', notificationId);
    } catch (error) {
      console.error('[Notifications] Error deleting notification:', error);
      throw error;
    }
  }
}